let scenesApplicationAppVersionEditNotUploadLabel = "未上传";
const en_US = {
  //region 通用翻译
  txt_return: "return",
  //endregion

  /*region scenes*/
  /*region common*/
  /*region Portal*/
  scenes_common_Portal_home: "Home",
  scenes_common_Portal_login: "Login",
  scenes_common_Portal_register: "Register",
  scenes_common_Portal_components_rapidRegs: "Rapid Regs",
  scenes_common_Portal_components_companion: "Companion",
  scenes_common_Portal_components_appMarket: "App Market",
  scenes_common_Portal_components_solutions: "Solutions",
  scenes_common_Portal_console: "Console",
  scenes_common_Portal_logout: "Logout",
  scenes_common_Portal_view_details: "View details",
  scenes_common_Portal_appMarketPortal: "Cloud Market",

  /*endregion Portal*/

  //region PlatformFrame
  scenes_common_PlatformFrame_home: "Main Home",
  //endregion

  /*region ConsoleHome*/
  scenes_common_ConsoleHome_VerifyingUserListComponent_userName: "username",
  scenes_common_ConsoleHome_VerifyingUserListComponent_registrationTime: "register_time",
  scenes_common_ConsoleHome_VerifyingUserListComponent_status: "status",
  scenes_common_ConsoleHome_VerifyingUserListComponent_viewAll: "view_all",
  scenes_common_ConsoleHome_VerifyingUserListComponent_title: "verifying user list",
  scenes_common_ConsoleHome_VerifyingEnterpriseListComponent_name: "enterprise_name",
  scenes_common_ConsoleHome_VerifyingEnterpriseListComponent_status: "enterprise_status",
  scenes_common_ConsoleHome_VerifyingEnterpriseListComponent_viewAll: "view_all",
  scenes_common_ConsoleHome_VerifyingEnterpriseListComponent_title: "pending Enterprises",
  scenes_common_ConsoleHome_VerifyingEnterpriseListComponent_submitTime: "Submit Time",

  scenes_common_ConsoleHome_EnterpriseListComponent_submitTime: "submit_time",
  scenes_common_ConsoleHome_EnterpriseListComponent_name: "Enterprise Name",
  scenes_common_ConsoleHome_EnterpriseListComponent_status: "Enterprise Status",
  scenes_common_ConsoleHome_EnterpriseListComponent_lastAuthTime: "Last Auth Time",
  scenes_common_ConsoleHome_EnterpriseListComponent_lastAuditor: "Last Auditor",
  scenes_common_ConsoleHome_EnterpriseListComponent_search: "Search",


  //region SideBar
  scenes_common_ConsoleHome_SideBar_Dashboard: "Dashboard",
  scenes_common_ConsoleHome_SideBar_Messages: "Messages",
  scenes_common_ConsoleHome_SideBar_Space: "Tenant Space",
  scenes_common_ConsoleHome_SideBar_CustomLogin: "Custom Login",
  scenes_common_ConsoleHome_SideBar_EnterpriseUsers: "Enterprise User",
  scenes_common_ConsoleHome_SideBar_EnterpriseApps: "Enterprise Application",
  scenes_common_ConsoleHome_SideBar_EnterpriseAppCategoryOneLabel: "Enterprise App Catalog 1",
  scenes_common_ConsoleHome_SideBar_EnterpriseAppCategoryTwoLabel: "Enterprise App Catalog 2",
  scenes_common_ConsoleHome_SideBar_AppCatalogManagementLabel: "App Catalog Management",
  scenes_common_ConsoleHome_SideBar_AccountInfoLabel: "Account Info",
  scenes_common_ConsoleHome_SideBar_AppMarketLabel: "App Market",
  scenes_common_ConsoleHome_SideBar_AlgorithmRepoLabel: "Algorithm Repository",
  //endregion

  //region Header
  scenes_common_ConsoleHome_Header_BasicSetting: "Basic Info",
  scenes_common_ConsoleHome_Header_SecuritySetting: "Security Setting",
  scenes_common_ConsoleHome_Header_Message: "Message",
  scenes_common_ConsoleHome_Header_Logout: "Logout",
  //endregion

  //region Menu_Item
  scenes_common_ConsoleHome_Menu_console: "Console",
  scenes_common_ConsoleHome_Menu_message: "Message",
  scenes_common_ConsoleHome_Menu_account: "Account",
  scenes_common_ConsoleHome_Menu_enterprise_account: "Enterprise Account",
  scenes_common_ConsoleHome_Menu_private_account: "Private Account",
  scenes_common_ConsoleHome_Menu_personnel: "Personnel Info",
  scenes_common_ConsoleHome_Menu_basic_manage: "Basic Data",
  scenes_common_ConsoleHome_Menu_enterprise_list: "Enterprise List",
  scenes_common_ConsoleHome_Menu_resource: "Resource",
  scenes_common_ConsoleHome_Menu_resource_monitor: "Resource Monitor",
  scenes_common_ConsoleHome_Menu_resource_price: "Resource Price",
  scenes_common_ConsoleHome_Menu_resource_discount: "Resource Discount",
  scenes_common_ConsoleHome_Menu_enterprise_verification: "Enterprise Verification",
  scenes_common_ConsoleHome_Menu_app_category_management: "App Category Management",
  scenes_common_ConsoleHome_Menu_app_verify_management: "App Verify Management",
  scenes_common_ConsoleHome_Menu_app_market_management: "App Market Management",
  scenes_common_ConsoleHome_Menu_portal_verification: "Portal Verification",
  scenes_common_ConsoleHome_Menu_enterprise_privilege: "Enterprise Privilege",
  scenes_common_ConsoleHome_Menu_algorithm_verification: "Algorithm Verification",
  scenes_common_ConsoleHome_Menu_meta_data: "Metadata",
  scenes_common_ConsoleHome_Menu_meta_data_list: "Metadata List",
  scenes_common_ConsoleHome_Menu_meta_data_category_verification: "Metadata Category Verification",
  scenes_common_ConsoleHome_Menu_meta_data_tree: "Metadata Tree",
  scenes_common_ConsoleHome_Menu_log_management: "Log Management",
  scenes_common_ConsoleHome_Menu_apps: "Apps",
  scenes_common_ConsoleHome_Menu_apps_list: "App Management",
  scenes_common_ConsoleHome_Menu_app_market: "App Market",
  scenes_common_ConsoleHome_Menu_tenant_app_management: "Tenant App Management",
  scenes_common_ConsoleHome_Menu_develop_project: "Develop Project",
  scenes_common_ConsoleHome_Menu_develop_app: "Develop App",
  scenes_common_ConsoleHome_Menu_publish_app: "Publish New App",
  scenes_common_ConsoleHome_Menu_app_private_management: "Private App Management",
  scenes_common_ConsoleHome_Menu_app_enterprise_management: "Enterprise App Management",
  scenes_common_ConsoleHome_Menu_algorithm: "Algorithms",
  scenes_common_ConsoleHome_Menu_algorithm_add: "Algorithm Add",
  scenes_common_ConsoleHome_Menu_algorithm_edit: "Algorithm Edit",
  scenes_common_ConsoleHome_Menu_algorithm_view: "Algorithm View",
  scenes_common_ConsoleHome_Menu_algorithm_list: "Algorithm Management",
  scenes_common_ConsoleHome_Menu_algorithm_repository_management: "Algorithm Repository Management",
  scenes_common_ConsoleHome_Menu_algorithm_category_management: "Algorithm Category",
  scenes_common_ConsoleHome_Menu_private_algorithm_management: "Private Algorithm Management",
  scenes_common_ConsoleHome_Menu_enterprise: "Enterprise",
  scenes_common_ConsoleHome_Menu_enterprise_info: "Enterprise Info",
  scenes_common_ConsoleHome_Menu_portal_configuration: "Portal Configuration",
  scenes_common_ConsoleHome_Menu_portal_logo: "Logo",
  scenes_common_ConsoleHome_Menu_portal_ad: "Advertisement",
  scenes_common_ConsoleHome_Menu_portal_service: "Service",
  scenes_common_ConsoleHome_Menu_portal_solution: "Solution",
  scenes_common_ConsoleHome_Menu_portal_news: "News",
  scenes_common_ConsoleHome_Menu_portal_companion: "Companion",
  scenes_common_ConsoleHome_Menu_portal_rapid_register: "Rapid Register",
  scenes_common_ConsoleHome_Menu_portal_affix: "Affix",
  scenes_common_ConsoleHome_Menu_portal_footer: "Footer",
  scenes_common_ConsoleHome_Menu_enterprise_meta_data: "Enterprise Metadata",
  scenes_common_ConsoleHome_Menu_department_management: "Department Management",
  scenes_common_ConsoleHome_Menu_role_management: "Role Management",
  scenes_common_ConsoleHome_Menu_enterprise_privilege_apply: "Enterprise Privilege Apply",
  scenes_common_ConsoleHome_Menu_tenant_resource: "Tenant Resource",
  scenes_common_ConsoleHome_Menu_tenant_resource_monitor: "Tenant Resource Monitor",
  scenes_common_ConsoleHome_Menu_tenant_resource_list: "Tenant Resource List",
  scenes_common_ConsoleHome_Menu_tenant_resource_apply: "Tenant Resource Apply",
  scenes_common_ConsoleHome_Menu_user_management: "User Management",
  scenes_common_ConsoleHome_Menu_user_list: "User List",
  scenes_common_ConsoleHome_Menu_user_invite: "User Invite",
  scenes_common_ConsoleHome_Menu_person_account_management: "Person Account Management",
  scenes_common_ConsoleHome_Menu_enterprise_account_management: "Enterprise Account Management",
  scenes_common_ConsoleHome_Menu_user_verification: "User Verification",
  scenes_ConsoleHome_EnterPrisePermissionComponent_permission: "Permission",
  scenes_ConsoleHome_EnterPrisePermissionComponent_mannage_permission: "Mannage Permission",
  scenes_common_ConsoleHome_Menu_equipments: "Data Acquisition Management",
  scenes_common_ConsoleHome_Menu_equipment_certify_verify: "Equipment Certify Verification",
  scenes_common_ConsoleHome_Menu_equipment_certify_list: "Equipment Certify Management",
  scenes_common_ConsoleHome_Menu_equipment_type_list: "Equipment Type Management",
  scenes_common_ConsoleHome_Menu_equipment_management: "Equipment Management",
  scenes_common_ConsoleHome_Menu_equipment_history_data: "History Data Management",
  //endregion

  //region Resource Monitor
  scenes_common_ConsoleHome_ResourceMonitorComponent_ResourceMonitor: "Resource Monitor",
  scenes_common_ConsoleHome_ResourceMonitorComponent_ResourceManagement: "Resource Management",
  scenes_common_ConsoleHome_ResourceMonitorComponent_CpuUsage: "Cpu Usage",
  scenes_common_ConsoleHome_ResourceMonitorComponent_MemoryRatio: "Memory Ratio",
  scenes_common_ConsoleHome_ResourceMonitorComponent_DiskRatio: "Disk Ratio",
  scenes_common_ConsoleHome_ResourceMonitorComponent_RouteRatio: "Route Ratio",
  scenes_common_ConsoleHome_ResourceMonitorComponent_InstanceRatio: "Instance Ratio",
  scenes_common_ConsoleHome_ResourceMonitorComponent_ServiceRatio: "Service Ratio",
  //endregion


  scenes_common_ConsoleHome_ProductListComponent_myApplication: "My Application",
  scenes_common_ConsoleHome_ProductListComponent_marketApplication: "Market Application",
  scenes_common_ConsoleHome_ProductListComponent_applicationName: "Application Name",
  scenes_common_ConsoleHome_ProductListComponent_applicationCategory: "Application Category",
  scenes_common_ConsoleHome_ProductListComponent_deploymentCount: "Deployment Count",
  scenes_common_ConsoleHome_ProductListComponent_query: "Query",
  scenes_common_ConsoleHome_ProductListComponent_reset: "Reset",

  //region 控制台应用显示页面
  scenes_ConsoleApplicationPage_return_console: "Return to console",
  //endregion

  //region Account Information
  scenes_common_ConsoleHome_Account_AccountBalanceLabel: "Account Balance",
  scenes_common_ConsoleHome_Account_Transfer: "Transfer",
  scenes_common_ConsoleHome_Account_Withdraw: "Withdraw",
  scenes_common_ConsoleHome_Account_AccountDetails: "Account Details",
  scenes_common_ConsoleHome_Account_ChooseTime: "Choose Time",
  scenes_common_ConsoleHome_Account_IncomeStatistics: "Income Statistics",
  scenes_common_ConsoleHome_Account_ExpenditureStatisticsNearly12Months: "Nearly 12 Months' Expenditure Statistics",
  scenes_commom_ConsoleHome_Account_Revenue: "Revenue",
  scenes_commom_ConsoleHome_Account_Expenditure: "Expenditure",
  scenes_commom_ConsoleHome_Account_RMB: "￥",
  scenes_common_ConsoleHome_Account_ImportRunningInfo: "Import RunningInfo",
  scenes_common_ConsoleHome_Account_BalanceOverview: "BalanceOverview",
  scenes_common_ConsoleHome_Account_ClassificationOverview: "ClassificationOverview",
  scenes_common_ConsoleHome_Account_Time: "scenes_common_ConsoleHome_Account_Time",
  scenes_common_ConsoleHome_Account_Category: "Category",
  scenes_common_ConsoleHome_Account_Content: "Content",
  scenes_common_ConsoleHome_Account_Income: "Income",
  scenes_common_ConsoleHome_Account_Cost: "Cost",
  scenes_common_ConsoleHome_Account_SumIncome: "TotalIncome ",
  scenes_common_ConsoleHome_Account_SumCost: "TotalConsumption",
  //endregion

  /*endregion ConsoleHome*/

  /*endregion common*/

  /*region user*/

  /*endregion user*/

  /*region enterprise*/

  /*endregion enterprise*/

  /*region role*/
  /*endregion role*/

  /*region application*/
  /*endregion application*/

  /*region algorithm*/
  scenes_common_ConsoleHome_AlgorithmListComponent_name: "algorithm_name",
  scenes_common_ConsoleHome_AlgorithmListComponent_updateTime: "updateTime",
  scenes_common_ConsoleHome_AlgorithmListComponent_status: "status",
  scenes_common_ConsoleHome_AlgorithmListComponent_developerName: "developer_name",
  scenes_common_ConsoleHome_AlgorithmListComponent_verifyAlgorithm: "Verify Algorithm",
  scenes_common_ConsoleHome_AlgorithmListComponent_pendingAlgorithm: "Pending Algorithm List",
  scenes_common_ConsoleHome_AlgorithmListComponent_search: "search",
  scenes_common_ConsoleHome_AlgorithmListComponent_reset: "reset",
  scenes_common_ConsoleHome_AlgorithmListComponent_algorithm: "Algorithm List",
  scenes_common_ConsoleHome_AlgorithmListComponent_algorithmName: "Algorithm Name",
  scenes_common_ConsoleHome_VerifyingAlgorithmListComponent_name: "algorithm_name",
  scenes_common_ConsoleHome_VerifyingAlgorithmListComponent_updateTime: "updateTime",
  scenes_common_ConsoleHome_VerifyingAlgorithmListComponent_status: "status",
  scenes_common_ConsoleHome_VerifyingAlgorithmListComponent_developerName: "developer_name",
  scenes_common_ConsoleHome_VerifyingAlgorithmListComponent_verifyAlgorithm: "Verify Algorithm",
  scenes_common_ConsoleHome_VerifyingAlgorithmListComponent_pendingAlgorithm: "Pending Algorithm List",
  scenes_common_ConsoleHome_VerifyingAlgorithmListComponent_search: "search",
  scenes_common_ConsoleHome_VerifyingAlgorithmListComponent_reset: "reset",
  scenes_common_ConsoleHome_VerifyingAlgorithmListComponent_algorithmStatus: "algorithmStatus",
  scenes_common_ConsoleHome_VerifyingAlgorithmListComponent_algorithmList: "algorithmManage",
  /*endregion algorithm*/

  /*region ApplicationNavigation*/
  scenes_common_ConsoleHome_ApplicationNavigation_application: "Enterprise Application Navigation",
  /*endregion ApplicationNavigation*/

  /*region space*/
  /*region SpaceAppsManagement*/
  scenes_SpaceAppsManagement_ApplicationType: "Application Type",
  scenes_SpaceAppsManagement_ApplicationName: "Application Name",
  scenes_SpaceAppsManagement_InstanceNum: "Instance Num",
  scenes_SpaceAppsManagement_CPU: "CPU",
  scenes_SpaceAppsManagement_Storage: "Storage",
  scenes_SpaceAppsManagement_Memory: "Memory",
  scenes_SpaceAppsManagement_URL: "URL",
  scenes_SpaceAppsManagement_State: "State",
  scenes_SpaceAppsManagement_SearchButton: "Search",
  scenes_SpaceAppsManagement_SearchPlaceHolder: "Search Application",
  scenes_SpaceAppsManagement_AllState: "All State",

  scenes_SpaceAppsManagement_Running: "Running",
  scenes_SpaceAppsManagement_Stopped: "Stopped",
  scenes_SpaceAppsManagement_Crashed: "Crashed",
  scenes_SpaceAppsManagement_Booting: "Booting",
  scenes_SpaceAppsManagement_state_unknown: "Unknown State",


  scenes_SpaceAppsManagement_MarketApplication: "Market Application",
  scenes_SpaceAppsManagement_CustomApplication: "Custom Application",
  /*endregion SpaceAppsManagement*/
  /*endregion space*/

  /*region app config and condition page*/
  scenes_AppConfigAndConditionPage_value_can_not_null: "This value can't be null",
  scenes_AppConfigAndConditionPage_app_name: "Application Name",
  scenes_AppConfigAndConditionPage_btn_save: "Update",
  scenes_AppConfigAndConditionPage_btn_reset: "Reset",
  scenes_AppConfigAndConditionPage_save_success: "Save Succeed",
  scenes_AppConfigAndConditionPage_save_fail: "Save Failed",
  scenes_AppConfigAndConditionPage_app_scaling: "Application Scaling",
  scenes_AppConfigAndConditionPage_label_cpu: "CPU Limit",
  scenes_AppConfigAndConditionPage_label_memory: "Memory Limit",
  scenes_AppConfigAndConditionPage_label_diskQuota: "Disk Limit",
  scenes_AppConfigAndConditionPage_value_should_be_integer: "This value should be integer",
  scenes_AppConfigAndConditionPage_app_instances: "Application Instances",
  scenes_AppConfigAndConditionPage_index: "#",
  scenes_AppConfigAndConditionPage_memory_usage: "Memory",
  scenes_AppConfigAndConditionPage_cpu_usage: "CPU",
  scenes_AppConfigAndConditionPage_disk_usage: "Disk",
  scenes_AppConfigAndConditionPage_app_event_records: "Event Records",
  scenes_AppConfigAndConditionPage_page_size: "Display {num} rows",
  scenes_AppConfigAndConditionPage_operation_success: "Operation Success",
  scenes_AppConfigAndConditionPage_operation_fail: "Operation Fail",


  /*endregion*/

  // region UserInvitationPage
  scenes_UserInvitationPage_wrong_format: "Wrong Format",
  scenes_UserInvitationPage_email_input_placeholder: "Please type email to invited. Format: name,email. i.e: Jane,jane@test.com",
  scenes_UserInvitationPage_email_input_button_label: "Inert e-mail",
  scenes_UserInvitationPage_file_input_label: "Select .CSV file, each row of this file should be name,email",
  scenes_UserInvitationPage_upload_button_label: "Import e-mail list",
  scenes_UserInvitationPage_email_search_placeholder: "Query by name, mail or state",
  scenes_UserInvitationPage_username_label: "name",
  scenes_UserInvitationPage_email_label: "e-mail",
  scenes_UserInvitationPage_table_status_title: "state",
  scenes_UserInvitationPage_table_invitation_url_title: "invitation url",
  scenes_UserInvitationPage_employee_create_time: "create time",
  scenes_UserInvitationPage_status_pending_invite: "Pending Invite",
  scenes_UserInvitationPage_status_pending_activate: "Pending Activate",
  scenes_UserInvitationPage_status_failed_to_invite: "Failed",
  scenes_UserInvitationPage_status_activated: "Activated",
  scenes_UserInvitationPage_status_timeout_to_activate: "Timeout",
  scenes_UserInvitationPage_status_disabled: "Disabled",
  scenes_UserInvitationPage_sending_spinner_label: "Sending request",
  scenes_UserInvitationPage_loading_spinner_label: "Loading data",
  scenes_UserInvitationPage_invite_button_label: "Invite",
  scenes_UserInvitationPage_invite_all: "Invite all",
  scenes_UserInvitationPage_delete_selected_user: "Delete Invitation",
  scenes_UserInvitationPage_export_invited_invitation_list: "Export Invited Invitation List",
  scenes_UserInvitationPage_export_uninvited_user_list: "Export Uninvited Invitation List",
  scenes_UserInvitationPage_invite_selected_user: "Send invitation",
  scenes_UserInvitationPage_email_existed: "Email already exists",
  scenes_UserInvitationPage_request_success: "Request succeed",
  scenes_UserInvitationPage_request_failed: "Request failed",
  scenes_UserInvitationPage_wrong_file_format: "Wrong file format",
  scenes_UserInvitationPage_invite_failed: "Invite failed",
  scenes_UserInvitationPage_invite_success: "Invite succeed",
  scenes_UserInvitationPage_some_invite_failed: "Part of invitations send failed",
  scenes_UserInvitationPage_invite_result: "Invite result",
  scenes_UserInvitationPage_delete_failed: "Delete failed",
  scenes_UserInvitationPage_delete_success: "Delete succeed",
  scenes_UserInvitationPage_some_delete_failed: "Part of Deletions failed",

  //endregion


  /*endregion scenes*/

  /*region components*/
  /*region HeaderLogo*/
  /*endregion HeaderLogo*/

  /*endregion components*/
  /**** handd CODE START ****/
  appTabLabel: "App",
  marketAppListTabLabel: "App List",
  publishMarketAppTabLabel: "Market App",
  subscribeAppTabLabel: "Subscribe App",
  buyMarketAppTablabel: "Buy Market App",

  /**** APP MARKET ****/
  //menu
  appMarketTabLabel: "App Market",

  //label
  appMarketAppNameLabel: "App Name",
  appMarketEnterpriseNameLabel: "Enterprise",
  appMarketAppKeywordLabel: "Keyword",
  //placeholder
  appMarketAppNamePlaceholder: "Please enter App Name",
  appMarketEnterpriseNamePlaceholder: "Please enter Enterprise",
  appMarketAppKeywordPlaceholder: "Please enter Keyword",

  appMarketLoadingModalTitle: "Loading...",
  /**** APP MARKET END ****/

  /**** PUBLISH APP ****/

  //table
  scenes_Application_PublishApplication_privilegeCode_title: "Privilege Code",
  scenes_Application_PublishApplication_privilegeName_title: "Privilege Name",
  scenes_Application_PublishApplication_privilegeDescription_title: "Privilege Description",
  scenes_Application_PublishApplication_periodMinMonths_title: "Min Months",
  scenes_Application_PublishApplication_periodMaxMonths_title: "Max Months",
  scenes_Application_PublishApplication_periodDescription_title: "Description",
  scenes_Application_PublishApplication_periodName_title: "Period Name",
  scenes_Application_PublishApplication_periodAmount_title: "Price Multiple",
  scenes_Application_PublishApplication_periodDiscount_title: "Discount",
  scenes_Application_PublishApplication_userMinUsers_title: "Min Users",
  scenes_Application_PublishApplication_userMaxUsers_title: "Max Users",
  scenes_Application_PublishApplication_userDescription_title: "Description",
  scenes_Application_PublishApplication_userDiscount_title: "Discount",
  scenes_Application_PublishApplication_operation_title: "Operation",

  //popconfirm
  scenes_Application_PublishApplication_popconfirm_title: "Delete?",
  scenes_Application_PublishApplication_popconfirmOK_title: "Confirm",
  scenes_Application_PublishApplication_popconfirmCancel_title: "Cancel",

  //label
  //scenes_Application_PublishApplication_order_label: "Binding Order",

  scenes_Application_PublishApplication_operation_label: "Operation",
  scenes_Application_PublishApplication_applicationInfo_label: "Application Info",
  scenes_Application_PublishApplication_applicationName_label: "App Name",
  scenes_Application_PublishApplication_applicationCode_label: "App Code",
  scenes_Application_PublishApplication_autoGenerate_label: "Automatic Generation",
  scenes_Application_PublishApplication_version_label: "Initial Version",
  scenes_Application_PublishApplication_applicationLogo_label: "App Logo",
  scenes_Application_PublishApplication_terminalType_label: "Terminal Type",
  scenes_Application_PublishApplication_uploadLogo_label: "Upload Logo",
  scenes_Application_PublishApplication_applicationCategory_label: "App Category",
  scenes_Application_PublishApplication_applicationDescription_label: "App Description",
  scenes_Application_PublishApplication_privilegeAllocation_label: "Privilege Allocation",
  scenes_Application_PublishApplication_helpFile_label: "Help File",
  scenes_Application_PublishApplication_apiFile_label: "API File",
  scenes_Application_PublishApplication_testReportFile_label: "Test Report File",
  scenes_Application_PublishApplication_applicationType_label: "App Type",
  scenes_Application_PublishApplication_sourceType_label: "Source Type",
  scenes_Application_PublishApplication_versionDescription_label: "Version Description",
  scenes_Application_PublishApplication_screenHeight_label: "Display Height",
  scenes_Application_PublishApplication_uploadScreenshot_label: "Uploading Screenshot",
  scenes_Application_PublishApplication_applicationFile_label: "App File",
  scenes_Application_PublishApplication_selectFile_label: "Select File",
  scenes_Application_PublishApplication_applicationPlan_label: "App Plan",
  scenes_Application_PublishApplication_applicationPlanName_label: "Resource Name",
  scenes_Application_PublishApplication_applicationPlanCost_label: "Resource Cost",
  scenes_Application_PublishApplication_applicationUnitRMB_label: "RMB",
  scenes_Application_PublishApplication_applicationUnitMonths_label: "RMB/month",
  scenes_Application_PublishApplication_memorySize_label: "GB",
  scenes_Application_PublishApplication_memorySizeUnit_label: "Limit Memory Size(GB)",
  scenes_Application_PublishApplication_diskQuota_label: "Limit Disk Quota(MB)",
  scenes_Application_PublishApplication_diskQuotaUnit_label: "MB",
  scenes_Application_PublishApplication_planDescription_label: "Plan Description",
  scenes_Application_PublishApplication_applicationPlanPeriod_label: "Application Plan Period",
  scenes_Application_PublishApplication_chargeDeploymentTime_label: "Charge at Deployment Time",
  scenes_Application_PublishApplication_deploymentTimeDiscounts_label: "Deployment Time Discounts",
  scenes_Application_PublishApplication_chargeUserNum_label: "Charging at the Number of Concurrent Users",
  scenes_Application_PublishApplication_userNumCost_label: "Price of Concurrent Users",
  scenes_Application_PublishApplication_applicationPeriod_label: "Period Discounts ",
  scenes_Application_PublishApplication_applicationUserConcurrent_label: "Discounts of Concurrent Users",
  scenes_Application_PublishApplication_chargeMode_label: "Charge Mode",
  scenes_Application_PublishApplication_charge_label: "Charge",
  scenes_Application_PublishApplication_byResource_label: "By Resource",
  scenes_Application_PublishApplication_deploymentTime_label: "Deployment Time",
  scenes_Application_PublishApplication_userNum_label: "Number of Concurrent Users",
  scenes_Application_PublishApplication_submitPublish_label: "Publish",
  scenes_Application_PublishApplication_submit_label: "Publish",
  scenes_Application_PublishApplication_return_label: "Return",
  scenes_Application_PublishApplication_previous_label: "Previous",
  scenes_Application_PublishApplication_next_label: "Next",

  //placeholder
  scenes_Application_PublishApplication_applicationName_placeholder: "Please enter App Name",
  scenes_Application_PublishApplication_applicationCode_placeholder: "Please enter App Code",
  scenes_Application_PublishApplication_applicationVersion_placeholder: "Please enter Initial Version",
  scenes_Application_PublishApplication_applicationCategory_placeholder: "Please select App Category",
  scenes_Application_PublishApplication_applicationDescription_placeholder: "Please enter App Description",
  scenes_Application_PublishApplication_applicationType_placeholder: "Please select App Type",
  scenes_Application_PublishApplication_sourceType_placeholder: "Please select Source Type",
  scenes_Application_PublishApplication_screenHeight_placeholder: "Please enter the display height",
  scenes_Application_PublishApplication_versionDescription_placeholder: "Please enter Version Description",
  scenes_Application_PublishApplication_planName_placeholder: "Please enter Resource Name",
  scenes_Application_PublishApplication_planCost_placeholder: "Please enter Resource Cost",
  scenes_Application_PublishApplication_memorySize_placeholder: "Please enter Memory Size",
  scenes_Application_PublishApplication_diskQuota_placeholder: "Please enter Disk Quota",
  scenes_Application_PublishApplication_planDescription_placeholder: "Please enter Plan Description",
  scenes_Application_PublishApplication_userNumCost_placeholder: "Please enter Price of concurrent users",

  // message
  scenes_Application_PublishApplication_required_message: "Required",
  scenes_Application_PublishApplication_incompletely_message: "Incompletely",
  scenes_Application_PublishApplication_notUpload_message: "Not Upload!",
  scenes_Application_PublishApplication_uploadLogo_message: "Please Upload App Logo",
  scenes_Application_PublishApplication_uploadAppFile_message: "Please Upload App File",
  scenes_Application_PublishApplication_promptName_message: "Please enter the application name and must be unique",
  scenes_Application_PublishApplication_promptCode_message: "Please enter the application code and must be unique",
  scenes_Application_PublishApplication_promptVersion_message: "Please enter Initial Version",
  scenes_Application_PublishApplication_promptCategory_message: "Please select App Category",
  scenes_Application_PublishApplication_promptDescription_message: "Please enter App Description",
  scenes_Application_PublishApplication_promptType_message: "Please select App Type",
  scenes_Application_PublishApplication_promptTerminalType_message: "Please select Terminal Type",
  scenes_Application_PublishApplication_promptSourceType_message: "Please select Source Type",
  scenes_Application_PublishApplication_promptVersionDescription_message: "Please enter Version Description",
  scenes_Application_PublishApplication_promptScreenHeight_message: "Please enter the Display Height",
  scenes_Application_PublishApplication_lessThan100MB_message: "Less Than 100MB",
  scenes_Application_PublishApplication_promptPlanName_message: "Please enter Resource Name",
  scenes_Application_PublishApplication_promptPlanCost_message: "Please enter Resource Cost",
  scenes_Application_PublishApplication_promptMemorySize_message: "Please enter Memory Size",
  scenes_Application_PublishApplication_promptDiskQuota_message: "Please enter Disk Quota",
  scenes_Application_PublishApplication_promptPlanDescription_message: "Please enter Plan Description",
  scenes_Application_PublishApplication_userNumCost_message: "Please enter Price of concurrent users",
  scenes_Application_PublishApplication_promptNotLimit_message: "Don't Limit",
  scenes_Application_PublishApplication_promptRedWord_message: "Red marking is mandatory！",

  //modal
  scenes_Application_PublishApplication_modal_submit_content: "Confirm the publish and submit it for audit？",
  scenes_Application_PublishApplication_modal_save_label: "save",
  scenes_Application_PublishApplication_modal_submit_label: "submit",
  scenes_Application_PublishApplication_modal_success_title: "Successful",
  scenes_Application_PublishApplication_modal_fail_title: "Failure",
  scenes_Application_PublishApplication_modal_submitSuccess_content: "Publish App Successful!",
  scenes_Application_PublishApplication_modal_submitFail_content: "Publish App Failure!",
  scenes_Application_PublishApplication_modal_uploadFileSuccess_content: "Upload File Successful!",
  scenes_Application_PublishApplication_modal_uploadFileFail_content: "Publish App Successful but Upload File Failure!",
  scenes_Application_PublishApplication_modal_OK_label: "OK",
  scenes_Application_PublishApplication_modal_cancel_label: "Cancel",
  scenes_Application_PublishApplication_modal_yes_label: "Yes",
  scenes_Application_PublishApplication_modal_no_label: "No",
  scenes_Application_PublishApplication_modal_sameName_content: "App Name already exists, please re-enter!",
  scenes_Application_PublishApplication_modal_sameCode_content: "App Code already exists, please re-enter!",

  //old
  // publishAppKeywordPlaceholder: "Please enter Keyword",
  // publishAppKeywordLabel: "Keyword",
  // publishAppIsPublishContent: "Whether to publish to the application market",
  // publishAppUploadLabel: "Upload",
  // publishAppSubmitLabel: "Publish",
  // publishAppCancelLabel: "Cancel",
  // publishAppPriviledgeFileButton: "Upload File",
  // publishAppHelpFileButton: "Upload File",
  // publishAppApiFileButton: "Upload File",
  // publishAppTestReportFileButton: "Upload File",
  // publishAppFileButton: "Upload File",
  // publishAppLoadingModalTitle: "Loading...",
  // publishAppNullModalTitle: "Error",
  // publishAppNullModalContentName: "App Name cannot be empty!",
  // publishAppNullModalContentVersion: "Initial Version cannot be empty!",
  // publishAppNullModalContentAppCategory: "App Category cannot be empty!",
  // publishAppNullModalContentDescription: "App Description cannot be empty!",
  // publishAppNullModalContentIconIamge: "Not find App Icon!",
  // publishAppNullFileModalContentIamgeSize: "Icon size should not exceed 100KB，please re-select!",
  // publishAppNullFileModalContent_priviledgeFileUrl: "Not find Priviledge File!",
  // publishAppNullFileModalContent_helpFileUrl: "Not find Help File!",
  // publishAppNullFileModalContent_apiFileUrl: "Not find API File!",
  // publishAppNullFileModalContent_testReportFileUrl: "Not find Test Report File!",
  // publishAppNullFileModalContent_appFileUrl: "Not find App File!",
  // publishAppNullFileModalContentNotUploadApp: "Not upload App File!",
  // publishAppNullFileModalContentSameName: "App Name already exists, please re-enter!",
  // publishAppNullModalConfirmLabel: "Got it",
  // publishAppSubmitModalTitle: "Confirm",
  // publishAppSubmitModalContent: "Found the selected image or file was not uploaded, continue to submit?",
  // publishAppSubmitModalConfirmLabel: "Confirm",
  // publishAppSubmitModalCancelLabel: "Cancel",
  // publishAppUploadSuccessModalTitle: "Successful",
  // publishAppUploadSuccessModalContent: "Upload successful!",
  // publishAppUploadSuccessModalConfirmLabel: "Confirm",
  // publishAppUploadSuccessModalCancelLabel: "Cancel",
  // publishAppUploadFailModalTitle: "Failure",
  // publishAppUploadFailModalContent: "Upload Fail!",
  // publishAppUploadFailModalConfirmLabel: "Confirm",
  // publishAppUploadFailModalCancelLabel: "Cancel",
  // publishAppFailModalTitle: "Failure",
  // publishAppFailModalContent: "Publish App Fail!",
  // publishAppFailModalConfirmLabel: "Confirm",
  // publishAppFailModalCancelLabel: "Cancel",
  /**** PUBLISH APP END ****/

  /**** DEPLOY MARKET APP ****/
  //menu
  deployMarketAppTabLabel: "Deploy Market App",

  //label
  deployMarketAppNameLabel: "App Name",
  deployMarketAppVersionLabel: "App Version",
  deployMarketAppAppTypeLabel: "App Type",
  deployMarketAppTitleLabel: "App Title",
  deployMarketAppSpaceLabel: "Tenant Space",
  deployMarketAppVisitLinkLabel: "Visit Link",
  deployMarketAppDomainLabel: "Domain",
  deployMarketAppSubmitLabel: "Deploy",
  deployMarketAppConfirmBuyLabel: "Confirm Buy",
  deployMarketAppCancelLabel: "Cancel",

  //placeholder`````
  deployMarketAppAppTitlePlaceholder: "Please enter App Title",
  deployMarketAppAppTypePlaceholder: "Please select App Type",
  deployMarketAppSpacePlaceholder: "Please select Tenant Space",
  deployMarketAppVisitLinkPlaceholder: "Please enter Visit Link",
  deployMarketAppDomainPlaceholder: "Please select Domain",
  deployMarketAppRandomVisitLink: "Random Visit Link",

  // loading modal
  deployMarketAppLoadingModalTitle: "Loading...",

  // null modal
  deployMarketAppNullModalTitle: "Error",
  deployMarketAppNullModalContentSpace: "Tenant Space cannot be empty!",
  deployMarketAppNullModalContentVisitLink: "Visit Link cannot be empty!",
  deployMarketAppNullModalContentDomain: "Visit Domain cannot be empty!",
  deployMarketAppNullModalConfirmLabel: "Got it",
  // deployMarketAppNullModalCancelLabel: "Cancel",

  // success modal
  deployMarketAppSuccessModalTitle: "Successful",
  deployMarketAppSuccessModalContent: "App deploy successful!",
  deployMarketAppSuccessModalConfirmLabel: "Confirm",
  deployMarketAppSuccessModalCancelLabel: "Cancel",

  // fail modal
  deployMarketAppFailModalTitle: "Failure",
  deployMarketAppFailModalContent: "App deploy fail!",
  deployMarketAppFailModalConfirmLabel: "Confirm",
  deployMarketAppFailModalCancelLabel: "Cancel",
  /**** DEPLOY MARKET END ****/

  /**** APP MAIN EDIT****/
  //label
  scenes_Application_AppMainEdit_applicationCode_label: "App Code:",
  scenes_Application_AppMainEdit_applicationType_label: "App Type",
  scenes_Application_AppMainEdit_applicationInfo1_label: "This Application is Published By",
  scenes_Application_AppMainEdit_applicationInfo2_label: "at",
  scenes_Application_AppMainEdit_applicationInfo3_label: "",
  scenes_Application_AppMainEdit_returnAppMarket_label: "Return App Market",
  scenes_Application_AppMainEdit_returnAppManagement_label: "Return Personal App Management",
  scenes_Application_AppMainEdit_audit_label: " Submit for Audit",
  scenes_Application_AppMainEdit_onlineApplication_label: "Online App",
  scenes_Application_AppMainEdit_offlineApplication_label: "Offline App",
  scenes_Application_AppMainEdit_closeApplication_label: "Close App",
  scenes_Application_AppMainEdit_applicationCategory_label: "App Category:",
  scenes_Application_AppMainEdit_applicationDescription_label: "Description:",
  scenes_Application_AppMainEdit_applicationLogo_label: "Logo",
  scenes_Application_AppMainEdit_uploadLogo_label: "Upload Logo",
  scenes_Application_AppMainEdit_applicationName_label: "App Name",
  scenes_Application_AppMainEdit_applicationModify_label: "Modify",
  scenes_Application_AppMainEdit_applicationSubmit_label: "Submit",
  scenes_Application_AppMainEdit_applicationCancel_label: "Cancel",
  scenes_Application_AppMainEdit_versionedList_label: "Version List",
  scenes_Application_AppMainEdit_publishNewVersionedApp_label: "Publish New Version",
  scenes_Application_AppMainEdit_plans_label: "Plans",
  scenes_Application_AppMainEdit_createPlan_label: "Create Plan",
  scenes_Application_AppMainEdit_modifyPlan_label: "Modify Plan",
  scenes_Application_AppMainEdit_deletePlan_label: "Delete Plan",

//placeholder
  scenes_Application_AppMainEdit_applicationName_placeholder: "Please enter Application Name",
  scenes_Application_AppMainEdit_applicationCategory_placeholder: "Please enter Application Category",
  scenes_Application_AppMainEdit_applicationDescription_placeholder: "Please enter Application Description",

  //message
  scenes_Application_AppMainEdit_applicationName_message: "Please enter Application Name!",
  scenes_Application_AppMainEdit_applicationCategory_message: "Please enter Application Category!",
  scenes_Application_AppMainEdit_applicationDescription_message: "Please enter Application Description!",
  scenes_Application_AppMainEdit_deploy_message: "It can only be deployed after online",

  //modal
  scenes_Application_AppMainEdit_modal_success_title: "Success",
  scenes_Application_AppMainEdit_modal_fail_title: "Fail",
  scenes_Application_AppMainEdit_modal_submitAudit_content: "Is it submitted for audit?",
  scenes_Application_AppMainEdit_modal_updateSuccess_content: "Update application information success,Is it submitted for audit?",
  scenes_Application_AppMainEdit_modal_updateFail_content: "Update application information failure",
  scenes_Application_AppMainEdit_modal_updateStatusSuccess_content1: "Submit Audit Success！",
  scenes_Application_AppMainEdit_modal_updateStatusFail_content1: "Submit Audit Fail！",
  scenes_Application_AppMainEdit_modal_updateStatusSuccess_content2: "Version Offline Success！",
  scenes_Application_AppMainEdit_modal_updateStatusFail_content2: "Version Offline Fail！",
  scenes_Application_AppMainEdit_modal_updateStatusSuccess_content3: "Version Online Success！",
  scenes_Application_AppMainEdit_modal_updateStatusFail_content3: "Version Online Fail！",
  scenes_Application_AppMainEdit_modal_updateStatusSuccess_content5: "Version Close Success！",
  scenes_Application_AppMainEdit_modal_updateStatusFail_content5: "Version Close Fail！",
  scenes_Application_AppMainEdit_modal_deletePlanSuccess_content: "Delete application plan success",
  scenes_Application_AppMainEdit_modal_deletePlanFail_content: "Delete application plan failure",
  scenes_Application_AppMainEdit_modal_OK_label: "OK",
  scenes_Application_AppMainEdit_modal_return_label: "Return",
  scenes_Application_AppMainEdit_modal_yes_label: "Yes",
  scenes_Application_AppMainEdit_modal_no_label: "No",

  //confirm modal
  scenes_Application_AppMainEdit_modal_confirm_title: "Confirm",
  scenes_Application_AppMainEdit_modal_online_content: "Confirm Online Application?",
  scenes_Application_AppMainEdit_modal_offline_content: "Confirm Offine Application?",
  scenes_Application_AppMainEdit_modal_close_content: "Confirm Close Application?",
  scenes_Application_AppMainEdit_modal_deletePlan_content: "Is it sure to delete the plan?",
  scenes_Application_AppMainEdit_modal_confirm_label: "Confirm",
  scenes_Application_AppMainEdit_modal_cancel_label: "Cancel",
  /**** APP MAIN END ****/

  /**** APP MAIN VIEW ****/
  //label
  scenes_Application_AppMainView_applicationCode_label: "App Code:",
  scenes_Application_AppMainView_applicationType_label: "App Type:",
  scenes_Application_AppMainView_applicationInfo1_label: "This Application is Published By",
  scenes_Application_AppMainView_applicationInfo2_label: "at",
  scenes_Application_AppMainView_applicationInfo3_label: "",
  scenes_Application_AppMainView_return_label: "Return",
  scenes_Application_AppMainView_applicationCategory_label: "App Category:",
  scenes_Application_AppMainView_applicationDescription_label: "Description:",
  scenes_Application_AppMainView_versionedList_label: "Version List",
  scenes_Application_AppMainView_plans_label: "Plans",
  /**** APP MAIN VIEW END ****/

  /**** APP VERSION EDIT ****/
  //table
  scenes_Application_AppVersionEdit_privilegeCode_title: "Privilege Code",
  scenes_Application_AppVersionEdit_privilegeName_title: "Privilege Name",
  scenes_Application_AppVersionEdit_privilegeDescription_title: "Privilege Description",
  scenes_Application_AppVersionEdit_operation_title: "Operation",

  //popconfirm
  scenes_Application_AppVersionEdit_popconfirmDelete_title: "Do you confirm the deletion？",
  scenes_Application_AppVersionEdit_popconfirmOK_title: "Confirm",
  scenes_Application_AppVersionEdit_popconfirmCancel_title: "Cancel",

  //label
  scenes_Application_AppVersionEdit_version_label: "Version",
  scenes_Application_AppVersionEdit_applicationType_label: "Application Type",
  scenes_Application_AppVersionEdit_versionInfo1_label: "The Version was Update by",
  scenes_Application_AppVersionEdit_versionInfo2_label: "at",
  scenes_Application_AppVersionEdit_versionInfo3_label: "",
  scenes_Application_AppVersionEdit_description_label: "Version Description",
  scenes_Application_AppVersionEdit_screenshot_label: "Application preview (screen  height {num}px)",
  scenes_Application_AppVersionEdit_screenHeight_label: "Screen Height",
  scenes_Application_AppVersionEdit_screenshots_label: "Upload Screenshots",
  scenes_Application_AppVersionEdit_sourceType_label: "Source Type",
  scenes_Application_AppVersionEdit_deploymentFile_label: "APP File",
  scenes_Application_AppVersionEdit_helpFile_label: "Help File",
  scenes_Application_AppVersionEdit_apiFile_label: "API File",
  scenes_Application_AppVersionEdit_testReportFile_label: "Test Report File",
  scenes_Application_AppVersionEdit_replaceFile_label: "Replace File",
  scenes_Application_AppVersionEdit_selectFile_label: "Select File",
  scenes_Application_AppVersionEdit_privilegeAllocation_label: "Privilege Allocation",
  scenes_Application_AppVersionEdit_download_label: "Download",
  scenes_Application_AppVersionEdit_notUpload_label: "Not Upload",
  scenes_Application_AppVersionEdit_uploaded_label: "Uploaded",
  scenes_Application_AppVersionEdit_audit_label: "Submit for Audit",
  scenes_Application_AppVersionEdit_online_label: "Online Version",
  scenes_Application_AppVersionEdit_disabled_label: "Version Disabled",
  scenes_Application_AppVersionEdit_modify_label: "Modify",
  scenes_Application_AppVersionEdit_save_label: "Save",
  scenes_Application_AppVersionEdit_cancel_label: "Cancel",
  scenes_Application_AppVersionEdit_return_label: "Return ",

  //placeholder
  scenes_Application_AppVersionEdit_description_placeholder: "Please Enter the Version Description",
  scenes_Application_AppVersionEdit_screenHeight_placeholder: "Please Enter the Screen Height",
  scenes_Application_AppVersionEdit_sourceType_placeholder: "Please Select the Source Type",

  //message
  scenes_Application_AppVersionEdit_required_message: "Required",
  scenes_Application_AppVersionEdit_sourceType_message: "Please Select the Source Type",
  scenes_Application_AppVersionEdit_description_message: "Please Enter the Version Description",
  scenes_Application_AppVersionEdit_screenHeight_message: "Please Enter the Screen Height",
  scenes_Application_AppVersionEdit_lessThan100MB_message: "Not Larger than 100MB",
  scenes_Application_AppVersionEdit_firstPage_message: "It's the First Page",
  scenes_Application_AppVersionEdit_lastPage_message: "It's the Last Page",

  //modal
  scenes_Application_AppVersionEdit_modal_audit_content: "Do you confirm the submit for audit？",
  scenes_Application_AppVersionEdit_modal_online_content: "Do you confirm the release of this version？",
  scenes_Application_AppVersionEdit_modal_disabled_content: "Do you confirm that this version is disabled？",
  scenes_Application_AppVersionEdit_modal_confirm_label: "Confirm",
  scenes_Application_AppVersionEdit_modal_cancel_label: "Cancel",

  scenes_Application_AppVersionEdit_modal_success_title: "Success",
  scenes_Application_AppVersionEdit_modal_fail_title: "Fail",
  scenes_Application_AppVersionEdit_modal_updateSuccess_content: "Save the update success.Do you confirm the submit for audit？",
  scenes_Application_AppVersionEdit_modal_updateFail_content: "Save update failure!",
  scenes_Application_AppVersionEdit_modal_updateStatusSuccess_content1: "Submit audit success！",
  scenes_Application_AppVersionEdit_modal_updateStatusFail_content1: "Submit audit fail!",
  scenes_Application_AppVersionEdit_modal_updateStatusSuccess_content3: "Version Online Success！",
  scenes_Application_AppVersionEdit_modal_updateStatusFail_content3: "Version Online Fail!",
  scenes_Application_AppVersionEdit_modal_updateStatusSuccess_content5: "Version Disabled Success！",
  scenes_Application_AppVersionEdit_modal_updateStatusFail_content5: "Version Disabled Fail!",
  scenes_Application_AppVersionEdit_modal_OK_label: "OK",
  scenes_Application_AppVersionEdit_modal_return_label: "Return",
  scenes_Application_AppVersionEdit_modal_yes_label: "Yes",
  scenes_Application_AppVersionEdit_modal_no_label: "No",
  /**** APP VERSION EDIT END ****/

  /**** APP VERSION VIEW ****/
  //table
  scenes_Application_AppVersionView_privilegeCode_title: "Privilege Code",
  scenes_Application_AppVersionView_privilegeName_title: "Privilege Name",
  scenes_Application_AppVersionView_privilegeDescription_title: "Privilege Description",
  scenes_Application_AppVersionView_operation_title: "Operation",

  //label
  scenes_Application_AppVersionView_version_label: "Application Version",
  scenes_Application_AppVersionView_applicationType_label: "Application Type",
  scenes_Application_AppVersionView_versionInfo1_label: "This Version is Update by",
  scenes_Application_AppVersionView_versionInfo2_label: "at",
  scenes_Application_AppVersionView_versionInfo3_label: "",
  scenes_Application_AppVersionView_description_label: "Version Details",
  scenes_Application_AppVersionView_screenshot_label: "Application preview (screen  height {num}px)",
  scenes_Application_AppVersionView_screenHeight_label: "Screen Height",
  scenes_Application_AppVersionView_screenshots_label: "Upload Screenshots",
  scenes_Application_AppVersionView_sourceType_label: "Source Type",
  scenes_Application_AppVersionView_deploymentFile_label: "APP File",
  scenes_Application_AppVersionView_helpFile_label: "Help File",
  scenes_Application_AppVersionView_apiFile_label: "API File",
  scenes_Application_AppVersionView_testReportFile_label: "Test Report File",
  scenes_Application_AppVersionView_replaceFile_label: "Replace File",
  scenes_Application_AppVersionView_selectFile_label: "Select File",
  scenes_Application_AppVersionView_privilegeAllocation_label: "Privilege Allocation",
  scenes_Application_AppVersionView_download_label: "Download",
  scenes_Application_AppVersionView_notUpload_label: "Not Upload",
  scenes_Application_AppVersionView_uploaded_label: "Uploaded",
  scenes_Application_AppVersionView_return_label: "Return",

  //message
  scenes_Application_AppVersionView_firstPage_message: "It's the First Page",
  scenes_Application_AppVersionView_lastPage_message: "It's the Last Page",


  /**** APP VERSION VIEW END ****/


  /**** APP MARKET PORTAL ****/
//label
  scenes_Application_AppMarketPortal_search_label: "Search",
  scenes_Application_AppMarketPortal_recommendApp_label: "RecommendApp",
  scenes_Application_AppMarketPortal_appCost_label: "Yuan/Month",
  scenes_Application_AppMarketPortal_appFree_label: "Free",
  scenes_Application_AppMarketPortal_algorithmLibrary_label: "AlgorithmLibrary",
  scenes_Application_AppMarketPortal_algorithmLibraryMore_label: "More",
  scenes_Application_AppMarketPortal_appMore_label: "More",

  //placeholder
  scenes_Application_AppMarketPortal_search_placeholder: "Enter the application name you need",

  /**** APP MARKET PORTAL END ****/


  /**** APP MARKET VIEW ****/

//label
  scenes_Application_AppMarketView_returnToAppMarket_label: "AppMarket",
  scenes_Application_AppMarketView_publishTime_label: "Publish Time",
  scenes_Application_AppMarketView_serviceEnterprise_label: "Service Enterprise",
  scenes_Application_AppMarketView_description_label: "Version Description",
  scenes_Application_AppMarketView_relatedDocuments_label: "Related Documents",
  scenes_Application_AppMarketView_applicationPreview_label: "APP Preview",
  scenes_Application_AppMarketView_mainAppInformation_label: "Main App",
  scenes_Application_AppMarketView_moduleInformation_label: "APP Module",
  scenes_Application_AppMarketView_productDetails_label: "Product Details",
  scenes_Application_AppMarketView_price_label: "Price",
  scenes_Application_AppMarketView_priceList_spec_label: "Specifications",
  scenes_Application_AppMarketView_priceList_cycle_label: "Cycle",
  scenes_Application_AppMarketView_priceList_price_label: "Price",
  scenes_Application_AppMarketView_priceList_cost_label: "yuan",
  scenes_Application_AppMarketView_priceList_buyNow_label: "Buy Now",
  scenes_Application_AppMarketView_priceList_notCompatible_label: "Version Not Compatible",

  //Recommend App
  scenes_Application_AppMarketView_recommend_label: "Related Recommendation",


  /**** APP MARKET VIEW  END ****/


  /**** APP MARKET LIST ****/
  //search
  scenes_Application_AppMarketList_search_label: "Search application",
  scenes_Application_AppMarketList_searchPrice_confirm_label: "Confirm",
  scenes_Application_AppMarketList_cost_label: "RMB",
  scenes_Application_AppMarketList_costFree_label: "Free",
  scenes_Application_AppMarketList_publishTime_label: "PublishTime",
  scenes_Application_AppMarketList_serviceEnterprise_label: "ServiceEnterprise",
  scenes_Application_AppMarketList_buyTimes_label: "BuyTimes",
  scenes_Application_AppMarketList_boughtTimes_label: "Times",
  scenes_Application_AppMarketList_buyNow_label: "BuyNow",

  //tag
  scenes_Application_AppMarketList_categoryTag_category_label: "Category classification",
  scenes_Application_AppMarketList_categoryTag_developSource_label: "Develop Source",
  scenes_Application_AppMarketList_categoryTag_enterprise_title: "Enterprise",
  scenes_Application_AppMarketList_categoryTag_developer_title: "Developer",
  scenes_Application_AppMarketList_categoryTag_price_label: "Price",
  scenes_Application_AppMarketList_categoryTag_priceFree_title: "Free",
  scenes_Application_AppMarketList_categoryTag_all_title: "all",

  //placeholder
  scenes_Application_AppMarketList_search_placeholder: "Enter the application name you need",

  /**** APP MARKET LIST END ****/

  /**** APP VERSION MAIN ****/
  //menu
  appVersionMainTabLabel: "App Version Main",

  //label
  appVersionMainReturnAppMarketLabel: "Return App Market",
  appVersionMainDescriptionLabel: "Version Description",
  appVersionMainKeywordLabel: "Keyword",
  appVersionMainAppCategoryLabel: "App Category",
  appVersionMainModifyApplicationLabel: "Modify",
  appVersionMainSubmitApplicationLabel: "Submit",
  appVersionMainCancelApplicationLabel: "Cancel",
  appVersionMainVersionedListLabel: "Version List",
  appVersionMainPublishNewVersionedAppLabel: "Publish New Version",
  appVersionMainPlansLabel: "Plans",
  appVersionMainCreatePlanLabel: "Create Plan",
  appVersionMainModifyPlanLabel: "Modify Plan",
  appVersionMainDeletePlanLabel: "Delete Plan",
  appVersionMainDeployApplicationLabel: "Deploy",
  appVersionMainOfflineApplicationLabel: "Offline",
  appVersionMainCloseApplicationLabel: "Mothball",
  //placeholder
  appVersionMainDescriptionPlaceholder: "Please enter Description",
  appVersionMainAppCategoryPlaceholder: "Please select AppCategory",

  // loading modal
  appVersionMainLoadingModalTitle: "Loading...",

  // null modal
  appVersionMainNullFileModalContent_priviledgeFileUrl: "Not find Priviledge File!",
  appVersionMainNullFileModalContent_helpFileUrl: "Not find Help File!",
  appVersionMainNullFileModalContent_apiFileUrl: "Not find API File!",
  appVersionMainNullFileModalContent_testReportFileUrl: "Not find Test Report File!",
  appVersionMainNullModalTitle: "Error",
  appVersionMainNullModalConfirmLabel: "Got it",
  // appVersionMainNullModalCancelLabel: "Cancel",

  // deploy modal
  appVersionMainDeployModalTitle: "Confirm",
  appVersionMainDeployModalContent: "Determine to deploy the application?",
  appVersionMainDeployModalConfirmLabel: "Yes",
  appVersionMainDeployModalCancelLabel: "Cance",

  // offline modal
  appVersionMainOfflineModalTitle: "Confirm",
  appVersionMainOfflineModalContent: "Select the status of the offline application",
  appVersionMainOfflineModalPendingAuthenticationLabel: "Pending Authentication",
  appVersionMainOfflineModalPendingPublishLabel: "Pending Publish",
  appVersionMainOfflineModalConfirmLabel: "Yes",
  appVersionMainOfflineModalCancelLabel: "Cance",

  // close modal
  appVersionMainCloseModalTitle: "Confirm",
  appVersionMainCloseModalContent: "Determine to mothball the application?",
  appVersionMainCloseModalConfirmLabel: "Yes",
  appVersionMainCloseModalCancelLabel: "Cance",

  // delete modal
  appVersionMainDeleteModalTitle: "Confirm",
  appVersionMainDeleteModalContent: "Determine to delete the plan?",
  appVersionMainDeleteModalConfirmLabel: "Delete",
  appVersionMainDeleteModalCancelLabel: "Cancel",


  appVersionMainModalContentUpdateApp: "Update App Info",
  appVersionMainModalContentUpdateStatus: "Update App Status",
  appVersionMainModalContentUploadFile: "Upload File",

  // success modal
  appVersionMainSuccessModalTitle: "Successful",
  appVersionMainSuccessModalContent: " Successful!",
  appVersionMainSuccessModalConfirmLabel: "Confirm",
  appVersionMainSuccessModalReturnLabel: "Return App Market",

  // fail modal
  appVersionMainFailModalTitle: "Failure",
  appVersionMainFailModalContent: " Failure!",
  appVersionMainFailModalConfirmLabel: "Confirm",
  appVersionMainFailModalReturnLabel: "Return App Market",

  // balance not enough modal
  appVersionMainBalanceNotEnoughModalTitle: "余额不足",
  appVersionMainBalanceNotEnoughModalContent: "您目前账户余额为¥{balance}元,为了保证正常使用本平台服务请及时充值!",
  appVersionMainBalanceNotEnoughModalConfirmLabel: "充值",
  appVersionMainBalanceNotEnoughModalCancelLabel: "Cancel",
  /**** APP VERSION MAIN END ****/

  /**** PUBLISH APP VERSION ****/
  //menu
  publishAppVersionTabLabel: "Publish App",

  //table
  scenes_Application_PublishAppVersion_privilegeCode_title: "Privilege Code",
  scenes_Application_PublishAppVersion_privilegeName_title: "Privilege Name",
  scenes_Application_PublishAppVersion_privilegeDescription_title: "Privilege Description",

  //popconfirm
  scenes_Application_PublishAppVersion_popconfirm_title: "Delete?",
  scenes_Application_PublishAppVersion_popconfirmOK_title: "Confirm",
  scenes_Application_PublishAppVersion_popconfirmCancel_title: "Cancel",

  //label
  scenes_Application_PublishAppVersion_applicationName_label: "App Name",
  scenes_Application_PublishAppVersion_version_label: "App Version",
  scenes_Application_PublishAppVersion_sourceType_label: "Source Type",
  scenes_Application_PublishAppVersion_versionDescription_label: "Version Description",
  scenes_Application_PublishAppVersion_applicationFile_label: "App File",
  scenes_Application_PublishAppVersion_helpFile_label: "Help File",
  scenes_Application_PublishAppVersion_apiFile_label: "API File",
  scenes_Application_PublishAppVersion_testReportFile_label: "Test Report File",
  scenes_Application_PublishAppVersion_selectFile_label: "Select File",


  //placeholder
  scenes_Application_PublishAppVersion_applicationVersion_placeholder: "Please enter Application Version",
  scenes_Application_PublishAppVersion_SourceType_placeholder: "Please select Source Type",
  scenes_Application_PublishAppVersion_versionDescription_placeholder: "Please enter Version Description",

  //message
  scenes_Application_PublishAppVersion_promptVersion_message: "Please enter Application Version",
  scenes_Application_PublishAppVersion_promptSourceType_message: "Please select Source Type",
  scenes_Application_PublishAppVersion_promptVersionDescription_message: "Please enter Version Description",

  // submit modal
  scenes_Application_PublishAppVersion_submitTitle_modal: "Confirm",
  scenes_Application_PublishAppVersion_submitContent_modal: "Found the selected file was not uploaded, continue to submit?",
  scenes_Application_PublishAppVersion_submitConfirm_modal: "Confirm",
  scenes_Application_PublishAppVersion_submitCancel_modal: "Cancel",

  // upload success modal
  scenes_Application_PublishAppVersion_uploadSuccess_title_modal: "Successful",
  scenes_Application_PublishAppVersion_uploadSuccess_content_modal: "Upload Successful!",
  scenes_Application_PublishAppVersion_uploadSuccess_confirmLabel_modal: "Confirm",
  scenes_Application_PublishAppVersion_uploadSuccess_cancelLabel_modal: "Cancel",

  // success modal

  scenes_Application_PublishAppVersion_successTitle_modal: "Successful",
  scenes_Application_PublishAppVersion_successContent_modal: "Publish new version successful!",
  scenes_Application_PublishAppVersion_successConfirmLabel_modal: "Confirm",
  scenes_Application_PublishAppVersion_successCancelLabel_modal: "Cancel",

  // upload fail modal
  scenes_Application_PublishAppVersion_uploadFail_title_modal: "Failure",
  scenes_Application_PublishAppVersion_uploadFail_titleContent_modal: "Upload Failure!",
  scenes_Application_PublishAppVersion_uploadFail_titleConfirmLabel_modal: "Confirm",
  scenes_Application_PublishAppVersion_uploadFail_titleCancelLabel_modal: "Cancel",

  // fail modal

  scenes_Application_PublishAppVersion_failTitle_modal: "Failure",
  scenes_Application_PublishAppVersion_failContent_modal: "Publish new version Fail!!",
  scenes_Application_PublishAppVersion_failConfirmLabel_modal: "Confirm",
  scenes_Application_PublishAppVersion_failCancelLabel_modal: "Cancel",

  /* //label
   publishAppVersionNameLabel: "App Name",
   publishAppVersionVersionLabel: "App Version",
   publishAppVersionDescriptionLabel: "Version Description",
   publishAppVersionPriviledgeFileLabel: "Priviledge File",
   publishAppVersionHelpFileLabel: "Help File",
   publishAppVersionApiFileLabel: "API File",
   publishAppVersionTestReportFileLabel: "Test Report File",
   publishAppVersionSourceTypeLabel: "Source Type",
   publishAppVersionFileLabel: "App File",
   publishAppVersionUploadLabel: "Upload",
   publishAppVersionSubmitLabel: "Publish",
   publishAppVersionCancelLabel: "Cancel",

   //placeholder
   publishAppVersionNamePlaceholder: "Please enter App Name",
   publishAppVersionVersionPlaceholder: "Please enter App Version",
   publishAppVersionDescriptionPlaceholder: "Please enter Version Description",
   publishAppVersionSourceTypePlaceholder: "Please select Source Type",

   // loading modal
   publishAppVersionLoadingModalTitle: "Loading...",

   // null modal
   publishAppVersionNullModalTitle: "Error",
   publishAppVersionNullModalContentName: "App Name cannot be empty!",
   publishAppVersionNullModalContentVersion: "App Version cannot be empty!",
   publishAppVersionNullModalContentDescription: "Version Description cannot be empty!",
   publishAppVersionNullFileModalContent_priviledgeFileUrl: "Not find Priviledge File!",
   publishAppVersionNullFileModalContent_helpFileUrl: "Not find Help File!",
   publishAppVersionNullFileModalContent_apiFileUrl: "Not find API File!",
   publishAppVersionNullFileModalContent_testReportFileUrl: "Not find Test Report File!",
   publishAppVersionNullFileModalContent_appFileUrl: "Not find App File!",
   publishAppVersionNullFileModalContentNotUploadApp: "Not upload App File!",
   publishAppVersionNullFileModalContentSameVersion: "Version already exists, please re-enter!",
   publishAppVersionNullModalConfirmLabel: "Got it",
   // publishAppVersionNullModalCancelLabel: "Cancel",

   // submit modal
   publishAppVersionSubmitModalTitle: "Confirm",
   publishAppVersionSubmitModalContent: "Found the selected file was not uploaded, continue to submit?",
   publishAppVersionSubmitModalConfirmLabel: "Confirm",
   publishAppVersionSubmitModalCancelLabel: "Cancel",

   // upload success modal
   publishAppVersionUploadSuccessModalTitle: "Successful",
   publishAppVersionUploadSuccessModalContent: "Upload successful!",
   publishAppVersionUploadSuccessModalConfirmLabel: "Confirm",
   publishAppVersionUploadSuccessModalCancelLabel: "Cancel",

   // success modal
   publishAppVersionSuccessModalTitle: "Successful",
   publishAppVersionSuccessModalContent: "Publish new version successful!",
   publishAppVersionSuccessModalConfirmLabel: "Confirm",
   publishAppVersionSuccessModalCancelLabel: "Cancel",

   // upload fail modal
   publishAppVersionUploadFailModalTitle: "Failure",
   publishAppVersionUploadFailModalContent: "Upload Fail!",
   publishAppVersionUploadFailModalConfirmLabel: "Confirm",
   publishAppVersionUploadFailModalCancelLabel: "Cancel",

   // fail modal
   publishAppVersionFailModalTitle: "Failure",
   publishAppVersionFailModalContent: "Publish new version Fail!",
   publishAppVersionFailModalConfirmLabel: "Confirm",
   publishAppVersionFailModalCancelLabel: "Cancel",*/
  /**** PUBLISH APP VERSION END ****/

  /**** ALGORITHM CATEGORY ****/

  //label
  scenes_Algorithm_AlgorithmCategory_add_label: "Add",
  scenes_Algorithm_AlgorithmCategory_save_label: "Save",
  scenes_Algorithm_AlgorithmCategory_delete_label: "Delete",
  scenes_Algorithm_AlgorithmCategory_reset_label: "Reset",
  scenes_Algorithm_AlgorithmCategory_logo_label: "Category Logo",
  scenes_Algorithm_AlgorithmCategory_name_label: "Category Name",
  scenes_Algorithm_AlgorithmCategory_remark_label: "Remark",
  scenes_Algorithm_AlgorithmCategory_new_label: "New Category",

  // loading
  algorithmCategoryLoadingModalTitle: "Loading...",

  // popconfirm
  scenes_Algorithm_AlgorithmCategory_popConfirm_delete_title: "Sure to delete the selected node?",
  scenes_Algorithm_AlgorithmCategory_popConfirm_reset_title: "Sure to reset the initial data?",
  scenes_Algorithm_AlgorithmCategory_popConfirm_confirm_label: "Confirm",
  scenes_Algorithm_AlgorithmCategory_popConfirm_cancel_label: "Cancel",

  // modal
  scenes_Algorithm_AlgorithmCategory_modal_success_title: "Success",
  scenes_Algorithm_AlgorithmCategory_modal_fail_title: "Fail",
  scenes_Algorithm_AlgorithmCategory_modal_saveSuccess_content: "Save success!",
  scenes_Algorithm_AlgorithmCategory_modal_saveFail_content: "Save fail!",
  scenes_Algorithm_AlgorithmCategory_modal_deleteSuccess_content: "Delete success!",
  scenes_Algorithm_AlgorithmCategory_modal_deleteFail_content: "Delete fail!",
  scenes_Algorithm_AlgorithmCategory_modal_OK_label: "OK",
  scenes_Algorithm_AlgorithmCategory_modal_cancel_label: "Cancel",

  /**** ALGORITHM CATEGORY END ****/

  /**** ALGORITHM LIST ****/

  //label
  scenes_Algorithm_AlgorithmList_name_label: "Algorithm name",
  scenes_Algorithm_AlgorithmList_createDate_label: "Upload Date",
  scenes_Algorithm_AlgorithmList_status_label: "Algorithm Status",
  scenes_Algorithm_AlgorithmList_add_label: "Add",
  scenes_Algorithm_AlgorithmList_modify_label: "Modify",
  scenes_Algorithm_AlgorithmList_delete_label: "Delete",
  scenes_Algorithm_AlgorithmList_detail_label: "Detail",

  //placeholder
  scenes_Algorithm_AlgorithmList_name_placeholder: "Filter Algorithm Name...",

  // popconfirm
  scenes_Algorithm_AlgorithmList_popConfirm_delete_title: "Sure to delete?",
  scenes_Algorithm_AlgorithmList_popConfirm_confirm_label: "Yes",
  scenes_Algorithm_AlgorithmList_popConfirm_cancel_label: "No",

  // modal
  scenes_Algorithm_AlgorithmList_modal_success_title: "Success",
  scenes_Algorithm_AlgorithmList_modal_fail_title: "Fail",
  scenes_Algorithm_AlgorithmList_modal_deleteSuccess_content: "Delete success!",
  scenes_Algorithm_AlgorithmList_modal_deleteFail_content: "Delete fail!",
  scenes_Algorithm_AlgorithmList_modal_offlineSuccess_content: "Offline Success！",
  scenes_Algorithm_AlgorithmList_modal_offlineFail_content: "Offline Fail！",
  scenes_Algorithm_AlgorithmList_modal_OK_label: "OK",
  scenes_Algorithm_AlgorithmList_modal_cancel_label: "Cancel",

  /**** ALGORITHM LIST END ****/

  /**** ALGORITHM ADD ****/

  // label
  scenes_Algorithm_AlgorithmAdd_description_label: "Algorithm Description",
  scenes_Algorithm_AlgorithmAdd_algorithmParameter_label: "AlgorithmParameter：",
  scenes_Algorithm_AlgorithmAdd_name_label: "Algorithm Name",
  scenes_Algorithm_AlgorithmAdd_category_label: "Algorithm Category",
  scenes_Algorithm_AlgorithmAdd_type_label: "Development Language",
  scenes_Algorithm_AlgorithmAdd_file_label: "Algorithm File",
  scenes_Algorithm_AlgorithmAdd_selectFile_label: "Select File",
  scenes_Algorithm_AlgorithmAdd_upload_label: "Upload",
  scenes_Algorithm_AlgorithmAdd_uploaded_label: "Uploaded",
  scenes_Algorithm_AlgorithmAdd_uploading_label: "Uploading",
  scenes_Algorithm_AlgorithmAdd_submit_label: "Save",
  scenes_Algorithm_AlgorithmAdd_return_label: "Return",
  scenes_Algorithm_AlgorithmAdd_card_label: "Algorithm Add",

  // placeholder
  scenes_Algorithm_AlgorithmAdd_description_placeholder: "Please enter Algorithm Description",
  scenes_Algorithm_AlgorithmAdd_name_placeholder: "Please enter Algorithm Name",
  scenes_Algorithm_AlgorithmAdd_category_placeholder: "Please select Algorithm Category",
  scenes_Algorithm_AlgorithmAdd_type_placeholder: "Please select Development Language",

  // table
  scenes_Algorithm_AlgorithmAdd_parameterName_title: "Parameter Name",
  scenes_Algorithm_AlgorithmAdd_parameterType_title: "Parameter Type",
  scenes_Algorithm_AlgorithmAdd_parameterDefaultValue_title: "Default Value",
  scenes_Algorithm_AlgorithmAdd_parameterScope_title: "Parameter Scope",
  scenes_Algorithm_AlgorithmAdd_parameterDescription_title: "Parameter Description",
  scenes_Algorithm_AlgorithmAdd_operation_title: "Operation",
  scenes_Algorithm_AlgorithmAdd_parameterAdd_label: "Add Parameter",
  scenes_Algorithm_AlgorithmAdd_confirmDelete_title: "Sure to offline?",
  scenes_Algorithm_AlgorithmAdd_confirm_label: "Confirm",
  scenes_Algorithm_AlgorithmAdd_cancel_label: "Cancel",
  scenes_Algorithm_AlgorithmAdd_delete_label: "Delete",

  // message
  scenes_Algorithm_AlgorithmAdd_description_message: "Please enter Algorithm Description",
  scenes_Algorithm_AlgorithmAdd_name_message: "Please enter Algorithm Name,and must be unique",
  scenes_Algorithm_AlgorithmAdd_sameName_message: "The Algorithm Name already exists,please re-enter",
  scenes_Algorithm_AlgorithmAdd_category_message: "Please select Algorithm Category",
  scenes_Algorithm_AlgorithmAdd_type_message: "Please select Development Language",
  scenes_Algorithm_AlgorithmAdd_upload_file_message: "Please upload Algorithm File",
  scenes_Algorithm_AlgorithmAdd_upload_algorithmFile_message: "Please upload Algorithm File",
  scenes_Algorithm_AlgorithmAdd_required_message: "Required",
  scenes_Algorithm_AlgorithmAdd_fileThan_message: "File must smaller than 100MB!",
  scenes_Algorithm_AlgorithmAdd_upload_success_message: "Upload success!",
  scenes_Algorithm_AlgorithmAdd_upload_fail_message: "Upload fail!",

  // modal
  scenes_Algorithm_AlgorithmAdd_modal_success_title: "Successful",
  scenes_Algorithm_AlgorithmAdd_modal_fail_title: "Failure",
  scenes_Algorithm_AlgorithmAdd_modal_submit_success_content: "Save success, do you submit the administrator audit?",
  scenes_Algorithm_AlgorithmAdd_modal_submit_fail_content: "Save fail!",
  scenes_Algorithm_AlgorithmAdd_modal_audit_success_content: "Submit audit success, please return the algorithm list home page.",
  scenes_Algorithm_AlgorithmAdd_modal_audit_fail_content: "Submit audit fail!",
  scenes_Algorithm_AlgorithmAdd_modal_OK_label: "OK",
  scenes_Algorithm_AlgorithmAdd_modal_cancel_label: "Cancel",
  scenes_Algorithm_AlgorithmAdd_modal_yes_label: "Yes",
  scenes_Algorithm_AlgorithmAdd_modal_no_label: "No",
  scenes_Algorithm_AlgorithmAdd_modal_return_title: "Confirm",
  scenes_Algorithm_AlgorithmAdd_modal_return_content: "You have added the content to return to the previous page",
  scenes_Algorithm_AlgorithmAdd_modal_return_OK_label: "OK",
  scenes_Algorithm_AlgorithmAdd_modal_return_cancel_label: "Cancel",

  // algorithmAddModalConfirmLabel: "Confirm",
  // algorithmAddModalReturnLabel: "Return",

  /**** ALGORITHM ADD END ****/

  /**** ALGORITHM EDIT ****/

  // label
  scenes_Algorithm_AlgorithmEdit_description_label: "Algorithm Description",
  scenes_Algorithm_AlgorithmEdit_name_label: "Algorithm Name",
  scenes_Algorithm_AlgorithmEdit_category_label: "Algorithm Category",
  scenes_Algorithm_AlgorithmEdit_type_label: "Development Language",
  scenes_Algorithm_AlgorithmEdit_file_label: "Algorithm File",
  scenes_Algorithm_AlgorithmEdit_selectFile_label: "Select File",
  scenes_Algorithm_AlgorithmEdit_changeFile_label: "Change File",
  scenes_Algorithm_AlgorithmEdit_algorithmParameter_label: "Algorithm Parameter：",
  scenes_Algorithm_AlgorithmEdit_upload_label: "Upload",
  scenes_Algorithm_AlgorithmEdit_uploaded_label: "Uploaded",
  scenes_Algorithm_AlgorithmEdit_uploading_label: "Uploading",
  scenes_Algorithm_AlgorithmEdit_audit_label: "Submit Audit",
  scenes_Algorithm_AlgorithmEdit_submit_label: "Save",
  scenes_Algorithm_AlgorithmEdit_return_label: "Return",
  scenes_Algorithm_AlgorithmEdit_card_label: "Algorithm Edit",

  // placeholder
  scenes_Algorithm_AlgorithmEdit_description_placeholder: "Please enter Algorithm Description",
  scenes_Algorithm_AlgorithmEdit_name_placeholder: "Please enter Algorithm Name",
  scenes_Algorithm_AlgorithmEdit_category_placeholder: "Please select Algorithm Category",
  scenes_Algorithm_AlgorithmEdit_type_placeholder: "Please select Development Language",

  // table
  scenes_Algorithm_AlgorithmEdit_parameterName_title: "Parameter Name",
  scenes_Algorithm_AlgorithmEdit_parameterType_title: "Parameter Type",
  scenes_Algorithm_AlgorithmEdit_defaultValue_title: "Default Value",
  scenes_Algorithm_AlgorithmEdit_parameterScope_title: "Parameter Scope",
  scenes_Algorithm_AlgorithmEdit_parameterDescription_title: "Parameter Description",
  scenes_Algorithm_AlgorithmEdit_operation_title: "Operation",
  scenes_Algorithm_AlgorithmEdit_add_label: "Add Parameter",
  scenes_Algorithm_AlgorithmEdit_confirmDelete_title: "Sure to offline?",
  scenes_Algorithm_AlgorithmEdit_confirm_title: "Confirm",
  scenes_Algorithm_AlgorithmEdit_cancel_title: "Cancel",
  scenes_Algorithm_AlgorithmEdit_delete_title: "Delete",

  // message
  algorithmEditDescriptionMessage: "Please enter Algorithm Description",
  scenes_Algorithm_AlgorithmEdit_name_message: "Please enter Algorithm Name,and must be unique",
  scenes_Algorithm_AlgorithmEdit_sameName_message: "The Algorithm Name already exists,please re-enter",
  scenes_Algorithm_AlgorithmEdit_category_message: "Please select Algorithm Category",
  scenes_Algorithm_AlgorithmEdit_type_message: "Please select Development Language",
  scenes_Algorithm_AlgorithmEdit_uploadFile_message: "Please upload Algorithm File",
  scenes_Algorithm_AlgorithmEdit_required_message: "Required",
  scenes_Algorithm_AlgorithmEdit_fileThan_message: "File must smaller than 100MB!",
  scenes_Algorithm_AlgorithmEdit_uploadSuccess_message: "Upload success!",
  scenes_Algorithm_AlgorithmEdit_uploadFail_message: "Upload fail!",

  // modal
  scenes_Algorithm_AlgorithmEdit_modal_success_title: "Successful",
  scenes_Algorithm_AlgorithmEdit_modal_fail_title: "Failure",
  scenes_Algorithm_AlgorithmEdit_modal_submitSuccess_content: "Save success, do you submit the administrator audit?",
  scenes_Algorithm_AlgorithmEdit_modal_submitFail_content: "Save fail!",
  scenes_Algorithm_AlgorithmEdit_modal_auditSuccess_content: "Submit audit success, please return the algorithm list home page.",
  scenes_Algorithm_AlgorithmEdit_modal_auditFail_content: "Submit audit fail!",
  scenes_Algorithm_AlgorithmEdit_modal_OK_label: "OK",
  scenes_Algorithm_AlgorithmEdit_modal_cancel_label: "Cancel",
  scenes_Algorithm_AlgorithmEdit_modal_return_label: "Return",
  scenes_Algorithm_AlgorithmEdit_modal_yes_label: "Yes",
  scenes_Algorithm_AlgorithmEdit_modal_no_label: "No",
  scenes_Algorithm_AlgorithmEdit_modal_returnConfirm_label: "Confirm",
  scenes_Algorithm_AlgorithmEdit_modal_return_content: "You have changed the content to return to the previous page",
  scenes_Algorithm_AlgorithmEdit_modal_returnOK_label: "OK",
  scenes_Algorithm_AlgorithmEdit_modal_returnCancel_label: "Cancel",

  // algorithmEditModalConfirmLabel: "Confirm",

  /**** ALGORITHM EDIT END ****/

  /**** ALGORITHM VIEW ****/

  // label
  scenes_Algorithm_AlgorithmView_description_label: "Algorithm Description",
  scenes_Algorithm_AlgorithmView_name_label: "Algorithm Name",
  scenes_Algorithm_AlgorithmView_category_label: "Algorithm Category",
  scenes_Algorithm_AlgorithmView_type_label: "Development Language",
  scenes_Algorithm_AlgorithmView_file_label: "Algorithm File",
  scenes_Algorithm_AlgorithmView_notUpload_label: "Not Upload",
  scenes_Algorithm_AlgorithmView_download_label: "Download",
  scenes_Algorithm_AlgorithmView_downloaded_label: "Downloaded",
  scenes_Algorithm_AlgorithmView_downloading_label: "Downloading",
  algorithmViewReturnLabel: "Return",
  //message
  scenes_Algorithm_AlgorithmView_downloadSuccess_message: "Download Success",
  scenes_Algorithm_AlgorithmView_downloadFail_message: "Download Fail",

  // table
  scenes_Algorithm_AlgorithmView_parameterName_title: "Parameter Name",
  scenes_Algorithm_AlgorithmView_parameterType_title: "Parameter Type",
  scenes_Algorithm_AlgorithmView_defaultValue_title: "Default Value",
  scenes_Algorithm_AlgorithmView_parameterScope_title: "Parameter Scope",
  scenes_Algorithm_AlgorithmView_parameterDescription_title: "Parameter Description",


  // algorithmViewTabLabel: "Algorithm View",

  /**** ALGORITHM VIEW END ****/

  /**** ALGORITHM LIBRARY ****/


  // placeholder
  scenes_Algorithm_AlgorithmLibrary_search_placeholder: "Search Algorithm Name",

  // label
  scenes_Algorithm_AlgorithmLibrary_name_label: "Algorithm Name",
  scenes_Algorithm_AlgorithmLibrary_developer_label: "Developer",
  scenes_Algorithm_AlgorithmLibrary_description_label: "Algorithm Description",
  scenes_Algorithm_AlgorithmLibrary_parameter_label: "Algorithm Parameter",

  // table
  scenes_Algorithm_AlgorithmLibrary_parameterName_title: "Parameter Name",
  scenes_Algorithm_AlgorithmLibrary_parameterType_title: "Parameter Type",
  scenes_Algorithm_AlgorithmLibrary_parameterDefaultValue_title: "Default Value",
  scenes_Algorithm_AlgorithmLibrary_parameterScope_title: "Parameter Scope",
  scenes_Algorithm_AlgorithmLibrary_parameterDescription_title: "Parameter Description",

  // loading modal
  // algorithmLibraryLoadingModalTitle: "Loading...",
  // algorithmLibraryTabLabel: "Algorithm Library",

  /**** ALGORITHM LIBRARY END ****/

  /**** ALGORITHM MANAGEMENT ****/
  // table
  scenes_Algorithm_AlgorithmManagement_algorithmName_title: "Algorithm Name",
  scenes_Algorithm_AlgorithmManagement_algorithmDate_title: "Upload Date",

  // label
  scenes_Algorithm_AlgorithmManagement_algorithmCategory_label: "Algorithm Category：",
  scenes_Algorithm_AlgorithmManagement_modifyCategory_label: "Modify Category",
  scenes_Algorithm_AlgorithmManagement_offlineAlgorithm_label: "Offline Algorithm",
  scenes_Algorithm_AlgorithmManagement_parameter_label: "Parameter",

  // placeholder
  scenes_Algorithm_AlgorithmManagement_search_placeholder: "Search Algorithm Name",

  //confirm modal
  scenes_Algorithm_AlgorithmManagement_modal_modifyCategory_title: "Modify Category",
  scenes_Algorithm_AlgorithmManagement_modal_offlineAlgorithm_content: "Do you confirm the offline of the selected algorithm？",
  scenes_Algorithm_AlgorithmManagement_modal_submit_label: "Submit",
  scenes_Algorithm_AlgorithmManagement_modal_confirm_label: "Confirm",
  scenes_Algorithm_AlgorithmManagement_modal_cancel_label: "Cancel",

  // modal
  scenes_Algorithm_AlgorithmManagement_modal_success_title: "Success",
  scenes_Algorithm_AlgorithmManagement_modal_fail_title: "Fail",
  scenes_Algorithm_AlgorithmManagement_modal_updateSuccess_content: "Modify Category Success！",
  scenes_Algorithm_AlgorithmManagement_modal_updateFail_content: "Modify Category Fail！",
  scenes_Algorithm_AlgorithmManagement_modal_offlineSuccess_content: "Offline Algorithm Success！",
  scenes_Algorithm_AlgorithmManagement_modal_offlineFail_content: "Offline Algorithm Fail！",
  scenes_Algorithm_AlgorithmManagement_modal_OK_label: "OK",
  scenes_Algorithm_AlgorithmManagement_modal_return_label: "Return",
  /**** ALGORITHM MANAGEMENT END ****/
  /**** handd CODE END ****/

  /**** USER SERVICE START ****/

  // EnterpriseInfo Start
  user_service_enterprise_logo_customization: "Customize",
  user_service_enterprise_verifying_status: "Pending authentication",
  user_service_enterprise_verifying_status_instruction: "Pending authentication, Please wait.",
  user_service_enterprise_verified_status: "Authenticated",
  user_service_enterprise_verified_status_instruction: "Authenticated, please click here to modify the information.",
  user_service_enterprise_verify_fail_status: "Authentication failed",
  user_service_enterprise_verify_fail_status_instruction: "Authentication failed, please resubmit the authentication information.",
  user_service_enterprise_verify_not_status: "Not authenticated",
  user_service_enterprise_verify_not_status_instruction: "Not authenticated, please authenticate yourself first.",
  // EnterpriseInfo End

  // PersonInfo Start
  user_service_person_info_welcome: "Welcome",
  user_service_person_info_role_label: "Role",
  user_service_person_info_company_label: "Companies",
  user_service_person_info_create_company_label: "Create new company",
  user_service_person_info_verifying_status: "Pending authentication",
  user_service_person_info_verifying_status_instruction: "Please wait for authentication.",
  user_service_person_info_verified_status: "Authenticated",
  user_service_person_info_verified_status_instruction: "Authenticated, please click here to modify the information.",
  user_service_person_info_verify_fail_status: "Authentication failed.",
  user_service_person_info_verify_fail_status_instruction: "Authentication failed, please resubmit the authentication.",
  user_service_person_info_verify_not_status: "Not authenticated.",
  user_service_person_info_verify_not_status_instruction: "Click here for authentication.",
  // PersonInfo End

  // MessageDetail Start
  user_service_message_msg_detail_panel_title: "View Message Detail",
  user_service_message_msg_detail_title: "Message title",
  user_service_message_msg_detail_type_label: "Message category",
  user_service_message_msg_detail_self_type_label: "Message type",
  user_service_message_msg_detail_publisher_label: "Publisher",
  user_service_message_msg_detail_created_at_label: "Time",
  user_service_message_msg_detail_receivers_label: "Receivers",
  user_service_message_msg_detail_confirm_btn_label: "Confirm",
  user_service_message_msg_detail_back_btn_label: "Back",
  user_service_message_msg_detail_delete_btn_label: "Delete",
  user_service_message_msg_detail_mark_as_read_success_notification: "Mark as read success.",
  user_service_message_msg_detail_mark_as_read_fail_notification: "Mark as read fail.",
  user_service_message_msg_detail_delete_success_notification: "Delete message success.",
  user_service_message_msg_detail_delete_fail_notification: "Delete message fail.",
  // MessageDetail End

  // MessageNew Start
  user_service_message_msg_new_modal_fail_retry_label: "Retry",
  user_service_message_msg_new_modal_fail_back_label: "Back",
  user_service_message_msg_new_modal_fail_header_label: "Publish fail",
  user_service_message_msg_new_modal_fail_content: "Failed to publish your message.",
  user_service_message_msg_new_modal_success_drawback_label: "Drawback",
  user_service_message_msg_new_modal_success_back_label: "Back",
  user_service_message_msg_new_modal_success_header_label: "Publish success",
  user_service_message_msg_new_modal_success_type_label: "Type",
  user_service_message_msg_new_modal_success_created_at_label: "Publish time",
  user_service_message_msg_new_modal_success_content_label: "Publish content",
  user_service_message_msg_new_modal_success_people_label: "Receivers",
  user_service_message_msg_new_modal_success_publisher_label: "Publisher",
  user_service_message_msg_new_modal_success_receiver_label: "Receivers",
  user_service_message_msg_new_search_placeholder_label: "Search by username",
  user_service_message_msg_new_receiver_label: "Receivers",
  user_service_message_msg_new_type_label: "Category",
  user_service_message_msg_new_self_type_label: "type",
  user_service_message_msg_new_title_label: "Title",
  user_service_message_msg_new_title_placeholder_label: "title",
  user_service_message_msg_new_content_label: "Content",
  user_service_message_msg_new_content_placeholder_label: "content",
  user_service_message_msg_new_publish_btn_label: "Publish",
  user_service_message_msg_new_back_btn_label: "Back",
  user_service_message_msg_new_success_txt: "Publish message success.",
  user_service_message_msg_new_fail_txt: "Publish message fail.",
  user_service_message_msg_new_drawback_success_txt: "Drawback message success.",
  user_service_message_msg_new_drawback_fail_txt: "Drawback message fail.",
  // MessageNew End

  // MessageSent Start
  user_service_message_sent_title_label: "Message title",
  user_service_message_sent_type_label: "Message category",
  user_service_message_sent_self_type_label: "Message type",
  user_service_message_sent_actor_label: "Publisher",
  user_service_message_sent_notifiers_label: "Receivers",
  user_service_message_sent_postOn_label: "Time",
  user_service_message_sent_new_self_type_placeholder: "Please enter type name",
  user_service_message_sent_panel_title: "Manage message list",
  user_service_message_sent_publish_btn_label: "Publish",
  user_service_message_sent_drawback_btn_label: "Drawback",
  user_service_message_sent_define_type_btn_label: "Self defined type",
  user_service_message_sent_search_placeholder: "Category,Type",
  user_service_message_sent_search_btn_label: "Search",
  user_service_message_sent_drawback_success_txt: "Message drawback success",
  user_service_message_sent_drawback_fail_txt: "Message drawback fail",
  user_service_message_sent_new_self_type_title: "Add new type",
  user_service_message_sent_new_self_type_ok_btn: "Confirm",
  user_service_message_sent_new_self_type_cancel_btn: "Cancel",
  user_service_message_sent_new_self_type_success_txt: "Create self defined type success.",
  user_service_message_sent_new_self_type_fail_txt: "Create self defined type fail.",
  // MessageSent End

  // MessageCenter Start
  user_service_message_msg_center_title: "Title",
  user_service_message_msg_center_publisher: "Publisher",
  user_service_message_msg_center_createdOn: "Time",
  user_service_message_msg_center_type: "Type",
  user_service_message_msg_center_panel_title: "Message Center",
  user_service_message_msg_center_delete_btn: "Delete",
  user_service_message_msg_center_mark_btn: "Mark as read",
  user_service_message_msg_center_delete_success: "Delete message success.",
  user_service_message_msg_center_delete_fail: "Delete message fail.",
  user_service_message_msg_center_read_success: "Mark as read success.",
  user_service_message_msg_center_read_fail: "Mark as read fail.",
  // MessageCenter End

  // PasswordStrength Start
  user_service_password_strength_weakest_txt: "Weakest",
  user_service_password_strength_weaker_txt: "Weak",
  user_service_password_strength_normal_txt: "Normal",
  user_service_password_strength_stronger_txt: "Strong",
  user_service_password_strength_strongest_txt: "Very Strong",
  user_service_password_strength_indicator_txt: "Strength",
  user_service_password_strength_requirement_one: "Please enter 6-20 characters",
  user_service_password_strength_requirement_two: "Must contain numbers, lower and upper case letters.",
  user_service_password_strength_requirement_three: "Cannot be the same as the username",
  user_service_password_strength_requirement_four: "Cannot contain the phone number",
  // PasswordStrength End

  // Register Start
  user_service_register_password_not_same: "Two password not same",
  user_service_register_username_not_unique: "The username has already been registered, please try another one.",
  user_service_register_email_not_unique: "The email has already been registered, please try another one.",
  user_service_register_phone_not_unique: "The phone has already been registered, please try another one.",
  user_service_register_validation_code_fail: "Please enter the right verification code.",
  user_service_register_get_validation_code: "Obtain verification code",
  user_service_register_validation_code_count_down: "seconds",
  user_service_register_title: "Welcome to register the sia cloud platform",
  user_service_register_submit_error: "Register information failed, please check and resubmit.",
  user_service_register_username_check: "Must have username, and should be unique.",
  user_service_register_username_placeholder: "Username",
  user_service_register_email_check: "Must have valid email address.",
  user_service_register_email_check_two: "Please enter your email.",
  user_service_register_email_placeholder: "Email",
  user_service_register_phone_check: "Must enter the valid phone number.",
  user_service_register_phone_check_two: "Please enter your phone.",
  user_service_register_phone_placeholder: "Phone",
  user_service_register_code_check: "Please enter the verification code.",
  user_service_register_code_placeholder: "Verification code",
  user_service_register_password_check: "Password must contain and only contain letters and numbers, the length should be 6 - 20 characters.",
  user_service_register_password_check_two: "Please enter your password",
  user_service_register_password_placeholder: "Password",
  user_service_register_confirm_check: "Please confirm your password",
  user_service_register_confirm_placeholder: "Confirm password",
  user_service_register_submit_btn: "Register",
  user_service_register_password_username_same: "Password can not be equal to username",
  // Register End

  // RegisterSuccess Start
  user_service_register_success_header_one: "Your account",
  user_service_register_success_header_two: "register successfully",
  // user_service_register_success_content: "Activation email has been sent to your email, the activation period is 24 hours. Please login to your email and click the activation link to activate your account.",
  user_service_register_success_content: "Register success, please login to use the system.",
  user_service_register_success_view_email: "View email",
  user_service_register_success_back: "Back",
  user_service_register_success_login: "Login",
  // RegisterSuccess End

  // VerifyRegister Start
  user_service_register_verify_success_title: "Activation success, please go to the home page to login.",
  user_service_register_verify_success_btn: "Go to login page",
  user_service_register_verify_fail_title: "Activation time out, please retry register.",
  user_service_register_verify_fail_register_btn: "Register",
  user_service_register_verify_fail_back_btn: "Back to home page",
  // VerifyRegister End

  // AssignUserRole Start
  user_service_assign_user_role_role_name: "Name",
  user_service_assign_user_role_role_description: "Description",
  user_service_assign_user_role_panel_title: "Assign user role",
  user_service_assign_user_role_save_btn: "Save",
  user_service_assign_user_role_back_btn: "Back",
  user_service_assign_user_role_success_txt: "Modify user role success.",
  user_service_assign_user_role_fail_txt: "Modify user role fail.",
  // AssignUserRole End

  // CompanyPrivilege Start
  user_service_company_privilege_name_col: "Name",
  user_service_company_privilege_description_col: "Description",
  user_service_company_privilege_status_col: "Status",
  user_service_company_privilege_panel: "Manage company privileges",
  user_service_company_privilege_apply_btn: "Apply",
  user_service_company_privilege_request_success_txt: "Request for new privileges success, please wait for approval.",
  user_service_company_privilege_request_fail_txt: "Request for new privileges fail, please retry later.",
  // CompanyPrivilege End

  // PrivilegeRoleConfig Start
  user_service_privilege_role_config_privilege_name_col: "Privilege name",
  user_service_privilege_role_config_privilege_description_col: "Description",
  user_service_privilege_role_config_panel_title: "Manage role privileges",
  user_service_privilege_role_config_role_label: "Role Name",
  user_service_privilege_role_config_app_label: "Application list",
  user_service_privilege_role_config_save_btn: "Save",
  user_service_privilege_role_config_back_btn: "Back",
  user_service_privilege_role_config_modify_success_txt: "Modify role privileges success.",
  user_service_privilege_role_config_modify_fail_txt: "Modify role privileges fail.",
  // PrivilegeRoleConfig End

  // RoleList Start
  user_service_role_list_name_col: "Role name",
  user_service_role_list_description_col: "Role description",
  user_service_role_list_add_role_modal_name: "Role name",
  user_service_role_list_add_role_modal_name_placeholder: "Please enter role name",
  user_service_role_list_add_role_modal_description: "Role description",
  user_service_role_list_add_role_modal_description_placeholder: "Please enter role description",
  user_service_role_list_delete_role_modal_description: "Confirm to delete the role",
  user_service_role_list_panel_title: "Role management",
  user_service_role_list_modal_ok: "Confirm",
  user_service_role_list_modal_cancel: "Cancel",
  user_service_role_list_add_btn: "Add",
  user_service_role_list_modify_btn: "Modify",
  user_service_role_list_delete_btn: "Delete",
  user_service_role_list_config_user_btn: "Config users",
  user_service_role_list_config_privilege_btn: "Config privileges",
  user_service_role_list_add_role_modal_title: "New",
  user_service_role_list_modify_role_modal_title: "Modify",
  user_service_role_list_acquire_role_modal_fail_txt: "Obtain roles fail.",
  user_service_role_list_delete_role_title: "Delete role",
  user_service_role_list_add_role_modal_success: "Create role success.",
  user_service_role_list_add_role_modal_fail: "Create role fail.",
  user_service_role_list_delete_role_modal_success: "Delete role success.",
  user_service_role_list_delete_role_modal_fail: "Delete role fail.",
  user_service_role_list_modify_role_modal_success: "Modify role success.",
  user_service_role_list_modify_role_modal_fail: "Modify role fail.",
  user_service_role_list_unknown_modal: "Unknown operation",
  // RoleList End

  // UserRoleAdd Start
  user_service_user_role_add_name_col: "Name",
  user_service_user_role_add_phone_col: "Phone",
  user_service_user_role_add_email_col: "Email",
  user_service_user_role_add_panel_title: "Add new employee to the role",
  user_service_user_role_add_save_btn: "Save",
  user_service_user_role_add_back_btn: "Back",
  user_service_user_role_add_save_success_txt: "Add employees to the company role list success.",
  user_service_user_role_add_save_fail_txt: "Add employees to the company role list fail.",
  // UserRoleAdd End

  // UserRoleConfig Start
  user_service_user_role_config_name_col: "Name",
  user_service_user_role_config_phone_col: "Phone",
  user_service_user_role_config_email_col: "Email",
  user_service_user_role_config_delete_modal_title: "Remove employee",
  user_service_user_role_config_delete_modal_ok: "Confirm",
  user_service_user_role_config_delete_modal_cancel: "Cancel",
  user_service_user_role_config_delete_modal_content: "Confirm to remove the employee from the role list.",
  user_service_user_role_config_panel_title: "Manage the role users",
  user_service_user_role_config_add_btn: "Add",
  user_service_user_role_config_delete_btn: "Remove",
  user_service_user_role_config_back_btn: "Back",
  user_service_user_role_config_search_placeholder: "Employee name",
  user_service_user_role_config_search_btn: "Search",
  user_service_user_role_config_fetch_fail: "Obtain company role list fail.",
  user_service_user_role_config_config_success: "Remove the employee from the role list success.",
  user_service_user_role_config_config_fail: "Remove the employee from the role list fail.",
  // UserRoleConfig End

  //User List Component(common)
  user_service_common_user_list_component_table_username: "username",
  user_service_common_user_list_component_table_email: "email",
  user_service_common_user_list_component_table_registerTime: "registerTime",
  user_service_common_user_list_component_button_inviteEmployee: "invite employee",
  user_service_common_user_list_component_button_manageEmployee: "manage employee",
  user_service_common_user_list_component_placeholder_username: "please input username",
  user_service_common_user_list_component_button_search: "search",
  user_service_common_user_list_component_bar_title: "sum with department",
  user_service_common_user_list_component_title: "user with enterprise list",
  //User List Component(common) End

  //Modify User Password
  user_service_modify_user_password_warning_password_not_equal: "password inconsistent",
  user_service_modify_user_password_warning_info: "The old password is wrong or the new password is not set correctly. Please check and resubmit.",
  user_service_modify_user_password_warning_old_password: "Please enter your old password",
  user_service_modify_user_password_placeholder_old_password: "old password",
  user_service_modify_user_password_info_new_password: "密码至少包含字母、数字以及“_”中的两种，并且在8位与20位之间",
  user_service_modify_user_password_warning_new_password: "Please enter your password",
  user_service_modify_user_password_placeholder_new_password: "new password",
  user_service_modify_user_password_warning_check_password: "Please confirm your password",
  user_service_modify_user_password_placeholder_check_password: "confirm password",
  user_service_modify_user_password_button: "submit",
  user_service_modify_user_password_success: "modify successfully",
  user_service_admin_reset_user_password_button: "reset",
  user_service_admin_reset_user_password_back: "back",
  //Modify User Password End

  //Register With Invitation Code
  user_service_register_with_invitation_code_success: "register successful",
  user_service_register_with_invitation_code_failure: "register failed",
  user_service_register_with_invitation_code_username_not_unique: "The username has already been registered, please try another one.",
  user_service_register_with_invitation_code_department_check: "You have not selected a department，please select one",
  user_service_register_with_invitation_code_position_check: "You have not selected a position yet, please select one",
  user_service_register_with_invitation_code_phone_not_unique: "The phone has already been registered, please try another one.",
  user_service_register_with_invitation_code_password_not_same: "Two password not same",
  user_service_register_with_invitation_code_validation_code_fail: "Please enter the right verification code.",
  user_service_register_with_invitation_code_get_validation_code: "Obtain verification code",
  user_service_register_with_invitation_code_validation_code_count_down: "seconds",
  user_service_register_with_invitation_code_card_title: "employee register page",
  user_service_register_with_invitation_code_submit_error: "Register information failed, please check and resubmit.",
  user_service_register_with_invitation_code_username_check: "Must have username, and should be unique.",
  user_service_register_with_invitation_code_username_placeholder: "用户名",
  user_service_register_with_invitation_code_email_placeholder: "邮箱",
  user_service_register_with_invitation_code_phone_check: "必须输入有效的手机号码",
  user_service_register_with_invitation_code_phone_check_two: "请输入你的手机号码",
  user_service_register_with_invitation_code_phone_placeholder: "手机号",
  user_service_register_with_invitation_code_code_check: "请输入验证码",
  user_service_register_with_invitation_code_code_placeholder: "验证码",
  user_service_register_with_invitation_code_invitation_code_placeholder: "邀请码",
  user_service_register_with_invitation_code_department_message: "请选择部门",
  user_service_register_with_invitation_code_department_placeholder: "选择部门",
  user_service_register_with_invitation_code_position_message: "请选择职位",
  user_service_register_with_invitation_code_position_placeholder: "选择职位",
  user_service_register_with_invitation_code_password_check: "密码至少包含字母、数字以及“_”两种，并且在8位与20位之间",
  user_service_register_with_invitation_code_password_check_two: "请输入你的密码",
  user_service_register_with_invitation_code_password_placeholder: "密码",
  user_service_register_with_invitation_code_confirm_check: "请确认你的密码",
  user_service_register_with_invitation_code_confirm_placeholder: "确认密码",
  user_service_register_with_invitation_code_submit_btn: "注册",
  //Register With Invitation Code End

  //User Details
  scenes_UserService_User_UserDetailsComponent_basicInfo: "basic information",
  scenes_UserService_User_UserDetailsComponent_username: "username",
  scenes_UserService_User_UserDetailsComponent_avatar: "avatar",
  scenes_UserService_User_UserDetailsComponent_email: "email",
  scenes_UserService_User_UserDetailsComponent_phone: "phone",
  scenes_UserService_User_UserDetailsComponent_metadata: "metadata",
  scenes_UserService_User_UserDetailsComponent_save: "save",
  scenes_UserService_User_UserDetailsComponent_back: "back",
  scenes_UserService_User_UserDetailsComponent_verifying_status: "Pending authentication",
  scenes_UserService_User_UserDetailsComponent_verifying_status_instruction: "Please wait for authentication.",
  scenes_UserService_User_UserDetailsComponent_verified_status: "Authenticated",
  scenes_UserService_User_UserDetailsComponent_verified_status_instruction: "Authenticated, please click here to modify the information.",
  scenes_UserService_User_UserDetailsComponent_verify_fail_status: "Authentication failed.",
  scenes_UserService_User_UserDetailsComponent_verify_fail_status_instruction: "Authentication failed, please resubmit the authentication.",
  scenes_UserService_User_UserDetailsComponent_verify_not_status: "Not authenticated.",
  scenes_UserService_User_UserDetailsComponent_verify_not_status_instruction: "Click here for authentication.",

  //Edit User Details
  scenes_UserService_User_EditUserDetailsComponent_basicInfo: "basic information",
  scenes_UserService_User_EditUserDetailsComponent_username: "username",
  scenes_UserService_User_EditUserDetailsComponent_avatar: "avatar",
  scenes_UserService_User_EditUserDetailsComponent_email: "email",
  scenes_UserService_User_EditUserDetailsComponent_phone: "phone",
  scenes_UserService_User_EditUserDetailsComponent_metadata: "metadata",
  scenes_UserService_User_EditUserDetailsComponent_save: "save",
  scenes_UserService_User_EditUserDetailsComponent_back: "back",
  scenes_UserService_User_EditUserDetailsComponent_confirmModal: "confirm",
  scenes_UserService_User_EditUserDetailsComponent_confirm: "confirm",
  scenes_UserService_User_EditUserDetailsComponent_cancel: "cancel",
  scenes_UserService_User_EditUserDetailsComponent_confirmChange: "Confirm changing?",
  scenes_UserService_User_EditUserDetailsComponent_emailCheck: "Please enter a valid email address!",
  scenes_UserService_User_EditUserDetailsComponent_emailRequiredMessage: "Please enter an email address!",
  scenes_UserService_User_EditUserDetailsComponent_emailUnique: "The email has already been registered, email must be unique!",
  scenes_UserService_User_EditUserDetailsComponent_phoneCheck: "Please enter a valid phone number!",
  scenes_UserService_User_EditUserDetailsComponent_phoneRequiredMessage: "Please enter a phone number!",
  scenes_UserService_User_EditUserDetailsComponent_phoneUnique: "The phone number has already been registered, phone number must be unique!",

  scenes_UserService_User_AdminEditUserComponent_success: "Edit user information success",

  //Create User Certify
  scenes_UserService_User_EditUserCertifyComponent_basicInfo: "basic information",
  scenes_UserService_User_EditUserCertifyComponent_realName: "real name",
  scenes_UserService_User_EditUserCertifyComponent_licenseLocation: "license location",
  scenes_UserService_User_EditUserCertifyComponent_licenseType: "license type",
  scenes_UserService_User_EditUserCertifyComponent_licenseNum: "license number",
  scenes_UserService_User_EditUserCertifyComponent_licenseValidTerm: "license valid term",
  scenes_UserService_User_EditUserCertifyComponent_licenseFrontImage: "license front image(color)",
  scenes_UserService_User_EditUserCertifyComponent_licenseBackImage: "license back image(color)",
  scenes_UserService_User_EditUserCertifyComponent_bankInfo: "bank information",
  scenes_UserService_User_EditUserCertifyComponent_bankAccountName: "bank account name",
  scenes_UserService_User_EditUserCertifyComponent_bankName: "bank name",
  scenes_UserService_User_EditUserCertifyComponent_bankAccountNum: "bank account number",
  scenes_UserService_User_EditUserCertifyComponent_submit: "submit",
  scenes_UserService_User_EditUserCertifyComponent_back: "back",
  scenes_UserService_User_EditUserCertifyComponent_warning: "warning",
  scenes_UserService_User_EditUserCertifyComponent_confirm: "confirm",
  scenes_UserService_User_EditUserCertifyComponent_cancel: "cancel",
  scenes_UserService_User_EditUserCertifyComponent_modalContent: "Modify user certify information will result in a new veryfication process, please confirm",

  //Create User Certify
  scenes_UserService_User_CreateUserCertifyComponent_basicInfo: "basic information",
  scenes_UserService_User_CreateUserCertifyComponent_realName: "real name",
  scenes_UserService_User_CreateUserCertifyComponent_licenseLocation: "license location",
  scenes_UserService_User_CreateUserCertifyComponent_licenseType: "license type",
  scenes_UserService_User_CreateUserCertifyComponent_licenseNum: "license number",
  scenes_UserService_User_CreateUserCertifyComponent_licenseValidTerm: "license valid term",
  scenes_UserService_User_CreateUserCertifyComponent_licenseFrontImage: "license front image(color)",
  scenes_UserService_User_CreateUserCertifyComponent_licenseBackImage: "license back image(color)",
  scenes_UserService_User_CreateUserCertifyComponent_bankInfo: "bank information",
  scenes_UserService_User_CreateUserCertifyComponent_bankAccountName: "bank account name",
  scenes_UserService_User_CreateUserCertifyComponent_bankName: "bank name",
  scenes_UserService_User_CreateUserCertifyComponent_bankAccountNum: "bank account number",
  scenes_UserService_User_CreateUserCertifyComponent_submit: "submit",
  scenes_UserService_User_CreateUserCertifyComponent_back: "back",
  scenes_UserService_User_CreateUserCertifyComponent_warning: "warning",
  scenes_UserService_User_CreateUserCertifyComponent_confirm: "confirm",
  scenes_UserService_User_CreateUserCertifyComponent_cancel: "cancel",
  scenes_UserService_User_CreateUserCertifyComponent_modalContent: "Submit user certify information will result in a veryfication process, please confirm",
  scenes_UserService_User_CreateUserCertifyComponent_realNameRequired: "Please enter your name!",
  scenes_UserService_User_CreateUserCertifyComponent_realNamePlaceholder: "Please enter your name",
  scenes_UserService_User_CreateUserCertifyComponent_licenseLocationRequired: "Please select your license location!",
  scenes_UserService_User_CreateUserCertifyComponent_licenseLocationPlaceholder: "Please select your license location",
  scenes_UserService_User_CreateUserCertifyComponent_licenseTypeRequired: "Please select your license type!",
  scenes_UserService_User_CreateUserCertifyComponent_licenseTypePlaceholder: "Please select your license type",
  scenes_UserService_User_CreateUserCertifyComponent_licenseNumRequired: "Please enter your license number!",
  scenes_UserService_User_CreateUserCertifyComponent_licenseNumPlaceholder: "Please enter your license number",
  scenes_UserService_User_CreateUserCertifyComponent_licenseValidTermRequired: "Please select your license expiry date!",
  scenes_UserService_User_CreateUserCertifyComponent_licenseValidTermPlaceholder: "Please select your license expiry date",
  scenes_UserService_User_CreateUserCertifyComponent_licenseFrontImageRequired: "Please upload the front image of your license!",
  scenes_UserService_User_CreateUserCertifyComponent_licenseBackImageRequired: "Please upload the back image of your license!",
  scenes_UserService_User_CreateUserCertifyComponent_bankAccountNameRequired: "Please enter your name!",
  scenes_UserService_User_CreateUserCertifyComponent_bankAccountNamePlaceholder: "Please enter your name",
  scenes_UserService_User_CreateUserCertifyComponent_bankNameRequired: "Please enter the name of the bank which you opened your account!",
  scenes_UserService_User_CreateUserCertifyComponent_bankNamePlaceholder: "Please enter the name of the bank which you opened your account",
  scenes_UserService_User_CreateUserCertifyComponent_bankAccountNumRequired: "Please enter your bank account number!",
  scenes_UserService_User_CreateUserCertifyComponent_bankAccountNumPlaceholder: "Please enter your bank account number",

  //Add User
  scenes_UserService_User_AddPlatformUserModal_username: "Username",
  scenes_UserService_User_AddPlatformUserModal_password: "Password",
  scenes_UserService_User_AddPlatformUserModal_check_password: "Confirm",
  scenes_UserService_User_AddPlatformUserModal_email: "Email",
  scenes_UserService_User_AddPlatformUserModal_phone: "Phone",
  scenes_UserService_User_AddPlatformUserModal_placeholder_username: "Please enter username",
  scenes_UserService_User_AddPlatformUserModal_placeholder_password: "Please enter password",
  scenes_UserService_User_AddPlatformUserModal_placeholder_check_password: "Please confirm password",
  scenes_UserService_User_AddPlatformUserModal_placeholder_email: "Please enter email",
  scenes_UserService_User_AddPlatformUserModal_placeholder_phone: "Please enter phone",
  scenes_UserService_User_AddPlatformUserModal_submit: "Submit",
  scenes_UserService_User_AddPlatformUserModal_cancel: "Cancel",
  scenes_UserService_User_AddPlatformUserModal_success: "Add User Success!",
  scenes_UserService_User_AddPlatformUserModal_success_commit: "Confirm",
  scenes_UserService_User_AddPlatformUserModal_usernameUnique: "Username registered",

  //Admin Reset User Password
  scenes_UserService_User_AdminResetUserPassword_username: "Username",
  scenes_UserService_User_AdminResetUserPassword_password: "New Password",
  scenes_UserService_User_AdminResetUserPassword_check_password: "Confirm",
  scenes_UserService_User_AdminResetUserPassword_placeholder_password: "Please enter new password",
  scenes_UserService_User_AdminResetUserPassword_placeholder_check_password: "Please confirm password",
  scenes_UserService_User_AdminResetUserPassword_submit: "Submit",
  scenes_UserService_User_AdminResetUserPassword_cancel: "Cancel",
  scenes_UserService_User_AdminResetUserPassword_success: "Reset Password Success!",
  scenes_UserService_User_AdminResetUserPassword_success_commit: "Confirm",

  //Create Enterprise Details
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_basicInfo: "basic information",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_name: "enterprise name",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_alias: "enterprise alias",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_logo: "enterprise logo",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_region: "enterprise region",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_address: "enterprise address",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_property: "enterprise property",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_profession: "enterprise profession",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_scale: "enterprise scale",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_metadata: "enterprise metadata",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_unifiedCreditId: "unified social credit Id",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_businessExpiryDate: "business expiry date",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_licenseImage: "enterprise license image(color)",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_bankInfo: "bank information",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_bankAccountName: "bank account name",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_taxpayerNum: "taxpayer number",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_bankName: "bank name",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_bankAccountNum: "bank account number",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreInfo: "representer information",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseLocation: "representer license location",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreName: "representer name",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseType: "representer license type",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseNum: "representer license number",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseExpiryDate: "representer license expiry date",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseFrontImage: "representer license front image(color)",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseBackImage: "representer license back image(color)",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_submit: "submit",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_back: "back",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_warning: "warning",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_cancel: "cancel",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_confirm: "confirm",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_modalContent: "Submit enterprise information will result in a veryfication process, please confirm",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_nameTip: "Please enter the full name registered at the Industrial and Commerical Bureau.",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_nameRequired: "Please enter the enterprise name!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_namePlaceholder: "Please enter the enterprise name",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_nameCheck: "The enterprise name has been registered, please choose another name",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_aliasRequired: "Please enter the enterprise alias!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_aliasPlaceholder: "Please enter the enterprise alias",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_logoRequired: "Please upload the enterprise logo!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_provinceRequired: "Please select a province!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_provincePlaceholder: "Please select a province",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_cityRequired: "Please select a city!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_cityPlaceholder: "Please select a city",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_districtRequired: "Please select a district!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_districtPlaceholder: "Please select a district",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_addressRequired: "Please enter the enterprise address!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_addressPlaceholder: "Please enter the enterprise address",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_propertyRequired: "Please select enterprise property!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_propertyPlaceholder: "Please select enterprise property",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_professionRequired: "Please select enterprise profession!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_professionPlaceholder: "Please select enterprise profession",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_scaleRequired: "Please select enterprise scale!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_scalePlaceholder: "Please select enterprise scale",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_metadataRequired: "Please enter enterprise metadata!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_metadataPlaceholder: "Please enter enterprise metadata",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_unifiedCreditIdRequired: "Please enter enterprise unified social credit Id!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_unifiedCreditIdPlaceholder: "Please enter enterprise unified social credit Id",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_businessExpiryDateRequired: "Please select business expiry date!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_businessExpiryDatePlaceholder: "Please select business expiry date",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_licenseImageRequired: "Please upload enterprise license image!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_bankAccountNameRequired: "Please enter enterprise bank account name!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_bankAccountNamePlaceholder: "Please enter enterprise bank account name",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_taxpayerNumRequired: "Please enter taxpayer number!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_taxpayerNumPlaceholder: "Please enter taxpayer number",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_taxpayerNumCheck: "Please enter correct taxpayer number",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_bankNameRequired: "Please enter enterprise bank name!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_bankNamePlaceholder: "Please enter enterprise bank name",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_bankAccountNumRequired: "Please enter enterprise bank account number!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_bankAccountNumPlaceholder: "Please enter enterprise bank account number",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_bankAccountNumCheck: "Please enter correct account number",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseLocationRequired: "Please select representer license location!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseLocationPlaceholder: "Please select representer license location",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreNameRequired: "Please enter representer name!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreNamePlaceholder: "Please enter representer name",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseTypeRequired: "Please select representer license type!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseTypePlaceholder: "Please select representer license type",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseNumRequired: "Please enter representer license number!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseNumPlaceholder: "Please enter correct license number",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseNumCheck: "Please enter representer license number",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseExpiryDateRequired: "Please select representer license expiry date!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseExpiryDatePlaceholder: "Please select representer license expiry date",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseFrontImageRequired: "Please upload the front image of representer license!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseBackImageRequired: "Please upload the back image of representer license!",

  //Edit Enterprise Details
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_basicInfo: "basic information",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_name: "enterprise name",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_alias: "enterprise alias",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_logo: "enterprise logo",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_region: "enterprise region",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_address: "enterprise address",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_property: "enterprise property",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_profession: "enterprise profession",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_scale: "enterprise scale",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_metadata: "enterprise metadata",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_unifiedCreditId: "unified social credit Id",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_businessExpiryDate: "business expiry date",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_licenseImage: "enterprise license image(color)",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_bankInfo: "bank information",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_bankAccountName: "bank account name",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_taxpayerNum: "taxpayer number",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_bankName: "bank name",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_bankAccountNum: "bank account number",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_repreInfo: "representer information",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_repreLicenseLocation: "representer license location",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_repreName: "representer name",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_repreLicenseType: "representer license type",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_repreLicenseNum: "representer license number",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_repreLicenseExpiryDate: "representer license expiry date",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_repreLicenseFrontImage: "representer license front image(color)",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_repreLicenseBackImage: "representer license back image(color)",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_submit: "submit",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_back: "back",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_warning: "warning",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_cancel: "cancel",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_confirm: "confirm",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_modalContent: "Modify enterprise information will result in a new veryfication process, please confirm",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_nameTip: "Please enter the full name registered at the Industrial and Commerical Bureau.",

  //Initialize Tenant Space
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_title: "Initialize Tenant Space",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_domainName: "domain name",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_platform: "platform",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_month: "period",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_quotaPlan: "quota plan",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_memSize: "memory",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_price: "memory price",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_description: "description",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_amount: "amount",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_confirm: "confirm",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_modalSuccess: "Initialize tenant space successful!",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_modalFail: "Initialize tenant space failed!",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_domainNameRequired: "Please enter a domain name!",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_domainNameCheck: "The domain name has been registered, domain name must be unique!",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_domainNameCheck2: "The domain name can only contains letters or number",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_domainNamePlaceholder: "Please enter a domain name, it cannot be modified after submit",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_monthRequired: "Please enter rent period!",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_monthPlaceholder: "Please enter rent period",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_monthCheck: "Months must be a positive integer!",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_monthAddon: "months",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_quotaPlanRequired: "Please select a quota plan!",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_quotaPlanPlaceholder: "Please select a quota plan",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_memSizePlaceholder: "Memory size will be displayed here based on your selection",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_pricePlaceholder: "Price will be displayed here based on your selection",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_priceValueBefore: "The current price is",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_priceValueAfter: "yuan per month",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_descriptionPlaceholder: "Description will be displayed here based on your selection",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_amountPlaceholder: "Amount will be displayed here based on your selection",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_amountValueAfter: "yuan",

  //Increase Quota
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_title: "Initialize Tenant Space",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_month: "period",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_quotaPlan: "quota plan",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_memSize: "memory",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_price: "price",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_description: "description",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_amount: "amount",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_upgrade: "upgrade",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_autopay: "auto renewal",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_monthRequired: "Please enter rent period!",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_monthPlaceholder: "Please enter rent period",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_monthCheck: "Months must be a positive integer!",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_monthAddon: "months",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_quotaPlanRequired: "Please select a quota plan!",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_quotaPlanPlaceholder: "Please select a quota plan",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_memSizePlaceholder: "Memory size will be displayed here based on your selection",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_pricePlaceholder: "Price will be displayed here based on your selection",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_priceValueBefore: "The current price is",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_priceValueAfter: "yuan per month",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_descriptionPlaceholder: "Description will be displayed here based on your selection",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_amountPlaceholder: "Amount will be displayed here based on your selection",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_amountValueAfter: "yuan",

  /**** USER SREVICE END ****/

  /**** BIG DATA SERVICE START ****/
  scenes_bigData_dataSet_list_title: "DataSet List",
  scenes_bigData_model_list_title: "Model List",
  scenes_bigData_project_list_title: "Project List",
  scenes_bigData_project_hub_my_work: "My Work",
  scenes_bigData_project_extension: "Extension",
  /**** BIG DATA SERVICE END ****/

  /**** BIG DATA DATASET MANAGEMENT START ****/
  scenes_dataset_management_upload_failed_message: "Upload failed,please try again.",
  scenes_dataset_management_modal_ok: "Ok",
  scenes_dataset_management_upload_success_modal_title: "Upload successfully!",
  scenes_dataset_management_upload_failed_modal_title: "Upload failed!",
  scenes_dataset_management_delete_success_modal_title: "Delete successfully",
  scenes_dataset_management_delete_failed_modal_title: "Delete failed",
  scenes_dataset_management_upload_type_message: "Please select correct type of file！",
  scenes_dataset_management_upload_size_message: "File must be less than 2MB!",
  scenes_dataset_management_upload_check: "Please upload a file！",
  scenes_dataset_management_form_file_label: "Upload file",
  scenes_dataset_management_form_file_required: "Please upload a file！",
  scenes_dataset_management_form_name_label: "Dataset name",
  scenes_dataset_management_form_name_required: "Please input dataset name",
  scenes_dataset_management_form_name_placeholder: "Please input dataset name",
  scenes_dataset_management_form_type_label: "Dataset type",
  scenes_dataset_management_form_type_required: "Please select dataset type",
  scenes_dataset_management_form_type_placeholder: "请选择数据集类型",
  scenes_dataset_management_form_category_label: "数据集类别",
  scenes_dataset_management_form_category_required: "请选择类别",
  scenes_dataset_management_form_category_placeholder: "请选择类别",
  scenes_dataset_management_form_description_label: "数据集描述",
  scenes_dataset_management_form_description_required: "请输入数据集描述",
  scenes_dataset_management_form_description_placeholder: "请输入数据集描述",
  scenes_dataset_management_button_submit: "上传",
  scenes_dataset_management_button_cancel: "取消",
  scenes_dataset_management_table_title_name: "名称",
  scenes_dataset_management_table_title_description: "说明",
  scenes_dataset_management_table_title_dataType: "数据类型",
  scenes_dataset_management_table_title_category: "数据集类别",
  scenes_dataset_management_table_title_createdAt: "创建时间",
  scenes_dataset_management_table_title_size: "数据大小",
  scenes_dataset_management_table_title_projectFileName: "工程",
  scenes_dataset_management_user_tab: "我的数据集",
  scenes_dataset_management_user_upload_button: "上传",
  scenes_dataset_management_user_save_button: "保存",
  scenes_dataset_management_user_delete_button: "删除",
  scenes_dataset_management_user_search_placeholder: "请输入数据集名称",
  scenes_dataset_management_system_tab: "系统数据集",
  scenes_dataset_management_system_search_placeholder: "请输入数据集名称",
  scenes_dataset_management_delete_modal_title: "删除用户",
  scenes_dataset_management_delete_modal_cancel: "取消",
  scenes_dataset_management_delete_modal_ok: "确认",
  scenes_dataset_management_delete_modal_message: "是否删除",
  /**** BIG DATA DATASET MANAGEMENT END ****/

  /**** zqy CODE START ****/

  /**** EQUIPMENT VERIFY DESTROY ****/
  //label
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_destroyCertify_label: "Destroy Certify",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_return_label: "Return",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_confirmDestroy_label: "Confirm Destroy",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_id_label: "GUID",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_description_label: "Description",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_destroyDescription_label: "Destroy Description",

  //modal
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_modal_success_title: "Success",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_modal_fail_title: "Fail",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_modal_submitSuccess_content: "Submit Success",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_modal_submitFail_content: "Submit Fail",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_modal_cancel_label: "Cancel",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_modal_OK_label: "OK",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_modal_return_title: "The content changes, confirm return？",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_modal_confirm_label: "Confirm",

  //message
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_destroyDescription_message: "Please enter Destroy Description!",

  //placeholder
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_destroyDescription_placeholder: "Please enter Destroy Description",

  /**** EQUIPMENT VERIFY DESTROY  END ****/

  /**** EQUIPMENT CERTIFY LIST ****/
  //label
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_id_label: "GUID",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_description_label: "Description",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_registerCompanyName_label: "Register Company",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_registerUserName_label: "Register User",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_validityTerm_label: "Validity Term",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_certifyStatus_label: "Status",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_certify_label: "Certify",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_destroy_label: "Destroy",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_delete_label: "Delete",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_copy_label: "Copy",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_download_label: "download",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_return_label: "Return",

  //popconfirm
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_popconfirm_destroy_title: "Confirm Destroy？",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_popconfirm_delete_title: "Confirm Delete？",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_popconfirm_OK_label: "Confirm",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_popconfirm_cancel_label: "Cancel",

  //modal
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_modal_success_title: "Success",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_modal_fail_title: "Fail",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_modal_deleteSuccess_content: "Delete Success",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_modal_deleteFail_content: "Delete Fail",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_modal_cancel_label: "Cancel",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_modal_OK_label: "OK",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_modal_return_title: "The content changes, confirm return？",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_modal_confirm_label: "Confirm",

  //message
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_copyId_message: "Authentication GUID has been copied!",

  /**** EQUIPMENT CERTIFY LIST END****/

  /**** EQUIPMENT CERTIFY REGISTER ****/
  //label
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_certifyRegister_label: "Certify Register",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_return_label: "Return",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_submitRegister_label: "Submit",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_validityTerm_label: "Validity Term",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_description_label: "Description",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_registerDescription_label: "Register Description",

  //modal
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_modal_success_title: "Success",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_modal_fail_title: "Fail",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_modal_submitSuccess_content: "Submit Success",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_modal_submitFail_content: "Submit Fail",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_modal_cancel_label: "Cancel",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_modal_OK_label: "OK",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_modal_return_title: "The content changes, confirm return？",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_modal_confirm_label: "Confirm",

  //message
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_validityTerm_message: "Please select Validity Term",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_description_message: "Please enter  Description!",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_registerDescription_message: "Please enter Register Description!",

  //placeholder
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_beginDate_placeholder: "Begin Date",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_endData_placeholder: "End Data",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_description_placeholder: "Please enter  Description",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_registerDescription_placeholder: "Please enter Register Description",

  /**** EQUIPMENT CERTIFY REGISTER END****/

  /**** CERTIFY VERIFY LIST ****/

  //label
  scenes_Equipment_EquipmentCertifyVerify_CertifyVerifyList_destroyCertify_label: "证书注销",
  scenes_Equipment_EquipmentCertifyVerify_CertifyVerifyList_return_label: "返回",
  scenes_Equipment_EquipmentCertifyVerify_CertifyVerifyList_confirmDestroy_label: "注销确认",

  //modal
  scenes_Equipment_EquipmentCertifyVerify_CertifyVerifyList_modal_success_title: "成功",
  scenes_Equipment_EquipmentCertifyVerify_CertifyVerifyList_modal_fail_title: "失败",
  scenes_Equipment_EquipmentCertifyVerify_CertifyVerifyList_modal_deleteSuccess_content: "删除成功",
  scenes_Equipment_EquipmentCertifyVerify_CertifyVerifyList_modal_deleteFail_content: "删除失败",
  scenes_Equipment_EquipmentCertifyVerify_CertifyVerifyList_modal_cancel_label: "取消",
  scenes_Equipment_EquipmentCertifyVerify_CertifyVerifyList_modal_OK_label: "好的",

  /**** CERTIFY VERIFY LIST END ****/

  /**** EQUIPMENT CERTIFY VERIFY ****/
  //title
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_id_title: "GUID",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_description_title: "Description",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_registerCompanyName_title: "Register Company",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_registerUserName_title: "Register User",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_registerTime_title: "Register Time",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_validityTerm_title: "Validity Term",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_verifyCategory_title: "Verify Category",

  //label
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_verifyCategory_label: "Verify Category",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_registerTime_label: "Register Time",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_all_label: "All",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_pass_label: "Pass",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_noPass_label: "No Pass",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_viewDescription_label: "View Description",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_query_label: "Query",

  //placeholder
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_startTime_placeholder: "Start Time",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_endTime_placeholder: "End Time",

  //confirm
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_confirm_verify_title: "Confirm pass verification？",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_confirm_reason_title: "Click ok and the reason for failure will be sent to the applicant.",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_confirm_reason_placeholder: "Please Enter Fail Reason",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_confirm_registerDescription_title: "Register Description",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_confirm_OK_label: "Confirm",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_confirm_cancel_label: "Cancel",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_confirm_off_label: "Off",

  //modal
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_modal_success_title: "Success",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_modal_fail_title: "Fail",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_modal_verifySuccess_content: "Verification Success",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_modal_verifyFail_content: "Verification Fail",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_modal_OK_label: "OK",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_modal_cancel_label: "Cancel",
  /**** EQUIPMENT CERTIFY VERIFY END****/

  /**** EQUIPMENT TYPE LIST ****/
  //label
  scenes_Equipment_EquipmentType_EquipmentTypeList_add_label: "Add",
  scenes_Equipment_EquipmentType_EquipmentTypeList_edit_label: "Edit",
  scenes_Equipment_EquipmentType_EquipmentTypeList_delete_label: "Delete",

  //modal
  scenes_Equipment_EquipmentType_EquipmentTypeList_modal_success_title: "Success",
  scenes_Equipment_EquipmentType_EquipmentTypeList_modal_fail_title: "Fail",
  scenes_Equipment_EquipmentType_EquipmentTypeList_modal_deleteSuccess_content: "Delete Success",
  scenes_Equipment_EquipmentType_EquipmentTypeList_modal_deleteFail_content: "Delete Fail",
  scenes_Equipment_EquipmentType_EquipmentTypeList_modal_cancel_label: "Cancel",
  scenes_Equipment_EquipmentType_EquipmentTypeList_modal_OK_label: "OK",

  //table
  scenes_Equipment_EquipmentType_EquipmentTypeList_id_title: "GUID",
  scenes_Equipment_EquipmentType_EquipmentTypeList_code_title: "Type Code",
  scenes_Equipment_EquipmentType_EquipmentTypeList_name_title: "Type Name",
  scenes_Equipment_EquipmentType_EquipmentTypeList_description_title: "Type Description",
  scenes_Equipment_EquipmentType_EquipmentTypeList_ifDynamic_title: "If Dynamic Config",
  scenes_Equipment_EquipmentType_EquipmentTypeList_ifDynamicYes_title: "Yes",
  scenes_Equipment_EquipmentType_EquipmentTypeList_ifDynamicNo_title: "No",

  //popconfirm
  scenes_Equipment_EquipmentType_EquipmentTypeList_popconfirm_delete_title: "Confirm Delete？",
  scenes_Equipment_EquipmentType_EquipmentTypeList_popconfirm_OK_label: "Confirm",
  scenes_Equipment_EquipmentType_EquipmentTypeList_popconfirm_cancel_label: "Cancel",
  //placeholder
  scenes_Equipment_EquipmentType_EquipmentTypeList_filterEquipmentTypeName_placeholder: "Filter Equipment Type Name",

  /**** EQUIPMENT TYPE LIST END ****/

  /**** EQUIPMENT TYPE ADD ****/
  //label
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_equipmentTypeAdd_label: "Add Equipment Type",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_return_label: "Return",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_submit_label: "Submit",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_name_label: "Type Name",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_code_label: "Type Code",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_ifDynamic_label: "If Dynamic Config",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_description_label: "Type Description",

  //message
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_name_message: "Please enter Type Name!",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_code_message: "Please enter Type Code!",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_description_message: "Please enter Type Description!",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_checkName_message: "The Type Name already exists,please re-enter",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_checkCode_message: "The Type Code already exists,please re-enter",
  //modal
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_modal_success_title: "Success",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_modal_fail_title: "Fail",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_modal_return_title: "The content changes, confirm return？",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_modal_addSuccess_content: "Add Success",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_modal_addFail_content: "Add Fail",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_modal_cancel_label: "Cancel",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_modal_OK_label: "OK",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_modal_confirm_label: "Confirm",

  // placeholder
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_name_placeholder: "Please enter Type Name!",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_code_placeholder: "Please enter Type Code!",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_description_placeholder: "Please enter Type Description!",

  /**** EQUIPMENT TYPE ADD END ****/
  /**** EQUIPMENT TYPE EDIT ****/

  //label
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_equipmentTypeEdit_label: "Edit Equipment Type",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_return_label: "Return",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_submit_label: "Submit",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_name_label: "Type Name",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_code_label: "Type Code",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_ifDynamic_label: "If Dynamic Config",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_description_label: "Type Description",

  //message
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_name_message: "Please enter Type Name!",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_code_message: "Please enter Type Code!",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_description_message: "Please enter Type Description!",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_checkName_message: "The Type Name already exists,please re-enter",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_checkCode_message: "The Type Code already exists,please re-enter",

  //modal
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_modal_success_title: "Success",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_modal_fail_title: "Fail",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_modal_return_title: "The content changes, confirm return？",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_modal_editSuccess_content: "Add Success",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_modal_editFail_content: "Add Fail",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_modal_cancel_label: "Cancel",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_modal_OK_label: "OK",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_modal_confirm_label: "Confirm",

  // placeholder
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_name_placeholder: "Please enter Type Name!",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_code_placeholder: "Please enter Type Code!",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_description_placeholder: "Please enter Type Description!",

  /**** EQUIPMENT TYPE EDIT END ****/
  /**** EQUIPMENT LIST ****/

  //table
  scenes_Equipment_EquipmentManagement_EquipmentList_id_title: "GUID",
  scenes_Equipment_EquipmentManagement_EquipmentList_equipmentType_title: "Equipment Type",
  scenes_Equipment_EquipmentManagement_EquipmentList_equipmentId_title: "Equipment Id",
  scenes_Equipment_EquipmentManagement_EquipmentList_registerCompanyName_title: "Register Company",
  scenes_Equipment_EquipmentManagement_EquipmentList_equipmentIp_title: "IP",
  scenes_Equipment_EquipmentManagement_EquipmentList_equipmentPort_title: "Port",
  scenes_Equipment_EquipmentManagement_EquipmentList_equipmentCertify_title: "Cert",
  scenes_Equipment_EquipmentManagement_EquipmentList_equipmentStatus_title: "Status",

  //modal
  scenes_Equipment_EquipmentManagement_EquipmentList_modal_success_title: "Success",
  scenes_Equipment_EquipmentManagement_EquipmentList_modal_fail_title: "Fail",
  scenes_Equipment_EquipmentManagement_EquipmentList_modal_stopSuccess_content: "Stop Success",
  scenes_Equipment_EquipmentManagement_EquipmentList_modal_stopFail_content: "Stop Fail",
  scenes_Equipment_EquipmentManagement_EquipmentList_modal_cancel_label: "Cancel",
  scenes_Equipment_EquipmentManagement_EquipmentList_modal_OK_label: "OK",
  //label
  scenes_Equipment_EquipmentManagement_EquipmentList_add_label: "Add",
  scenes_Equipment_EquipmentManagement_EquipmentList_edit_label: "Edit",
  scenes_Equipment_EquipmentManagement_EquipmentList_config_label: "Config",
  scenes_Equipment_EquipmentManagement_EquipmentList_checkData_label: "Check Data",
  scenes_Equipment_EquipmentManagement_EquipmentList_log_label: "View Log",
  scenes_Equipment_EquipmentManagement_EquipmentList_commandGive_label: "Give Command ",
  scenes_Equipment_EquipmentManagement_EquipmentList_stopEquipment_label: "Stop Equipment",

  //placeholder
  scenes_Equipment_EquipmentManagement_EquipmentList_filterEquipmentType_placeholder: "Filter Equipment Type",

  /**** EQUIPMENT LIST END ****/

  /**** EQUIPMENT CONFIG ****/
  //table
  scenes_Equipment_EquipmentManagement_EquipmentConfig_name_title: "Node Name",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_alias_title: "Alias",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_description_title: "Description",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_dataType_title: "Data Type",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_dataUnit_title: "Data Unit",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_sampleMode_title: "Sample Mode",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_period_title: "Sample Period",

  //label
  scenes_Equipment_EquipmentManagement_EquipmentConfig_equipmentGuid_label: "Equipment GUID：",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_generalConfig_label: "General Config",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_transferProtocol_label: "Transfer Protocol",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_compressMethod_label: "Compress Method",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_dataTransferUrl_label: "Data Transfer Url",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_fileTransferUrl_label: "File Transfer Url",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_period_label: "Transfer Period",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_buffer_label: "Data buffer",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_nodeConfig_label: "Node Config",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_return_label: "Return",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_next_label: "Next",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_previous_label: "Previous",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_submit_label: "Done",

  //message
  scenes_Equipment_EquipmentManagement_EquipmentConfig_required_message: "Required",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_transferProtocol_message: "Please select Transfer Protocol",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_compressMethod_message: "Please select Compress Method",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_dataTransferUrl_message: "Please enter Data Transfer Url",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_fileTransferUrl_message: "Please enter File Transfer Url",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_period_message: "Please enter Transfer Period",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_buffer_message: "Please enter Data buffer",

  //placeholder
  scenes_Equipment_EquipmentManagement_EquipmentConfig_transferProtocol_placeholder: "Please select Transfer Protocol",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_compressMethod_placeholder: "Please select Compress Method",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_dataTransferUrl_placeholder: "Please enter Data Transfer Url",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_fileTransferUrl_placeholder: "Please enter File Transfer Url",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_period_placeholder: "Please enter Transfer Period",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_buffer_placeholder: "Please enter Data buffer",

  //  modal
  scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_return_title: "Confirm",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_return_content: "The content changes, confirm return？",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_return_OK_label: "Confirm",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_return_cancel_label: "Cancel",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_success_title: "Success",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_fail_title: "Fail",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_submitSuccess_content: "Save Equipment Config Success!",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_submitFail_content: "Save Equipment Config Fail!",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_OK_label: "OK",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_cancel_label: "Return",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_yes_label: "Yes",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_no_label: "No",
  /**** EQUIPMENT CONFIG END ****/

  /**** EQUIPMENT DATA VIEW ****/
  // table
  scenes_Equipment_EquipmentManagement_EquipmentDataView_nodeName_title: "Node Name",
  scenes_Equipment_EquipmentManagement_EquipmentDataView_alias_title: "Alias",
  scenes_Equipment_EquipmentManagement_EquipmentDataView_description_title: "Description",
  scenes_Equipment_EquipmentManagement_EquipmentDataView_dataType_title: "Data Type",
  scenes_Equipment_EquipmentManagement_EquipmentDataView_dataUnit_title: "Data Unit",
  scenes_Equipment_EquipmentManagement_EquipmentDataView_value_title: "Value",
  scenes_Equipment_EquipmentManagement_EquipmentDataView_timeStamp_title: "Time",
  scenes_Equipment_EquipmentManagement_EquipmentDataView_receive_ts_title: "Receive Time",
  scenes_Equipment_EquipmentManagement_EquipmentDataView_timeStamp_error: "Error Time",
  //label
  scenes_Equipment_EquipmentManagement_EquipmentDataView_return_label: "Return",

  /**** EQUIPMENT DATA VIEW END ****/

  /**** EQUIPMENT DETAIL ****/
  //table
  scenes_Equipment_EquipmentManagement_EquipmentDetail_name_title: "Node Name",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_alias_title: "Alias",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_description_title: "Aescription",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_dataType_title: "Data Type",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_dataUnit_title: "Data Unit",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_sampleMode_title: "Sample Mode",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_period_title: "Sample Period",

  //label
  scenes_Equipment_EquipmentManagement_EquipmentDetail_equipmentInfo_label: "Equipment Info",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_equipmentType_label: "Equipment Type",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_equipmentId_label: "Equipment Id",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_equipmentIp_label: "Equipment Ip",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_equipmentPort_label: "Equipment Port",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_equipmentCertify_label: "Equipment Certify",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_equipmentStatus_label: "Equipment Status",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_equipmentConfig_label: "Equipment Config",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_transferProtocol_label: "Transfer Protocol",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_compressMethod_label: "Compress Method",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_dataTransferUrl_label: "DataTransfer Url",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_fileTransferUrl_label: "FileTransfer Url",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_period_label: "Period",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_buffer_label: "Buffer",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_collectNodeConfig_label: "CollectNode Config",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_return_label: "return",
  /**** EQUIPMENT DETAIL END ****/

  /**** EQUIPMENT LOG ****/
  //table
  scenes_Equipment_EquipmentManagement_EquipmentLog_time_title: "Log Time",
  scenes_Equipment_EquipmentManagement_EquipmentLog_logType_title: "Log Type",
  scenes_Equipment_EquipmentManagement_EquipmentLog_content_title: "Log Content",

  //label
  scenes_Equipment_EquipmentManagement_EquipmentLog_search_label: "Search",
  scenes_Equipment_EquipmentManagement_EquipmentLog_reset_label: "Reset",

  //placeholder
  scenes_Equipment_EquipmentManagement_EquipmentLog_beginDate_placeholder: "Start Date",
  scenes_Equipment_EquipmentManagement_EquipmentLog_endData_placeholder: "End Date",
  scenes_Equipment_EquipmentManagement_EquipmentLog_types_placeholder: "Log Type",
  /**** EQUIPMENT LOG END ****/

  /**** FEEDBACK ****/
  scense_Feedback_submit_successfully: "Your feedback has been submitted.",
  scense_Feedback_submit_failed: "Your feedback fail to submit",
  scense_Feedback_card: "feedback",
  scense_Feedback_username_required_message: "please input username",
  scense_Feedback_username_placeholder: "username",
  scense_Feedback_email_required_message: "please input email",
  scense_Feedback_email_placeholder: "email",
  scense_Feedback_phone_required_message: "please input phone number",
  scense_Feedback_phone_placeholder: "phone number",
  scense_Feedback_content_required_message: "please input content",
  scense_Feedback_content_placeholder: "content",
  scense_Feedback_submit_button: "submit",
  scense_Feedback_return_button: "return",
  /**** FEEDBACK END ****/

  /**** ENTERPRISE APPS COMPONENT ****/
  scense_enterprise_apps_component_state_running: "running",
  scense_enterprise_apps_component_state_crashed: "crashed",
  scense_enterprise_apps_component_state_stopped: "stopped",
  scense_enterprise_apps_component_table_appName: "appName",
  scense_enterprise_apps_component_table_state: "runningState",
  scense_enterprise_apps_component_table_instances: "instances",
  scense_enterprise_apps_component_table_memory: "memory",
  scense_enterprise_apps_component_table_diskQuota: "diskQuota",
  scense_enterprise_apps_component_card_title: "Enterprise Apps List",
  scense_enterprise_apps_component_ringChart_running_label: "running rate",
  scense_enterprise_apps_component_ringChart_crashed_label: "crashed rate",
  scense_enterprise_apps_component_ringChart_stopped_label: "stopped rate",
  scense_enterprise_apps_component_button: "app management",
  /**** ENTERPRISE APPS COMPONENT END ****/
};

export default en_US
